<template>
  <div class="wrap">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-if="checkList.length == 0">
      <div class="header-search-wrap">
        <font-awesome-icon :icon="['fas', 'search']" style="font-size: 16px; color: #aaa; margin-right: 10px" />
        <el-input class="head-search list clearable" placeholder="リスト内のインフルエンサーを検索" clearable v-model="sort_keyword" @input="sortKeyword()"></el-input>
      </div>
      <div class="header-filter-wrap pointer" :class="filter_show || filtered ? 'active' : ''" @click="filter_show = !filter_show">
        <span>
          <font-awesome-icon :icon="['fal', 'sliders-h']" style="margin-right: 5px" />
          フィルターの追加
        </span>
      </div>
      <div class="header-filter-clear" v-show="filtered" @click="loadQuery()">
        フィルターのクリア
        <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 3px" />
      </div>
      <div @click="changeListView('pagination')" v-if="list_view_style != 'pagination'" class="router-link small"   style="margin-right:15px; font-weight:700">
        <span class="new-tag">NEW</span>
        新しいリストビューを試す
      </div>
      <div class="flex-space"></div>
      <el-button
        type="primary"
        size="small"
        @click="openBioSlideSettingModal()"
        :disabled="bio_slide_setting_modal"
      >
        <font-awesome-icon :icon="['fas', 'file-alt']" style="margin-right: 5px" />AI紹介スライド出力
      </el-button>
    </div>
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div>
        <div class="check-wrap">
          <div class="check-parts" style="color: #666">{{ checkList.length }}名を選択中</div>
          <div class="check-parts pointer" @click="deleteInfluencer()" v-if="!list_detail.master"><i class="el-icon-delete" style="font-size: 14px"></i>リストから削除</div>
          <div class="check-parts pointer" @click="openEditDrawer()" v-if="!list_detail.master"><i class="el-icon-edit" style="font-size: 14px"></i>一括編集</div>

          <addListButton :checkList.sync="checkList" :sns_type="list_detail.sns_type" :list_id="list_id" style="margin-right: 7px" @loadList="loadList" />
          <moveListButton
            v-if="!list_detail.master"
            :checkList.sync="checkList"
            :sns_type="list_detail.sns_type"
            :list_id="list_id"
            :comment_columns="comment_columns"
            style="margin-right: 7px"
            @loadQuery="loadQuery"
            @loadList="loadList"
            @loadListDetail="loadListDetail"
            @refreshInfluencerUpdateStatus="refreshInfluencerUpdateStatus"
          />

          <el-tooltip v-if="list_detail.sns_type == 'instagram'" :disabled="is_send_bulk_message.status">
            <div v-if="!is_send_bulk_message.status && is_send_bulk_message.message === ''" class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <div v-else-if="is_send_bulk_message.message !== ''" slot="content">
              {{ is_send_bulk_message.message }}
            </div>
            <span style="margin-right: 7px">
              <el-button
                type="primary"
                size="small"
                @click="openNewmessageDrawer()"
                :disabled="!is_send_bulk_message.status || newmessage_drawer"
              >
                <font-awesome-icon :icon="['fas', 'paper-plane']" style="margin-right: 5px" />メッセージ
              </el-button>
            </span>
          </el-tooltip>

          <el-tooltip :disabled="is_influencer_bio_slide.status">
            <div v-if="is_influencer_bio_slide.message !== ''" slot="content">
              {{ is_influencer_bio_slide.message }}
            </div>
            <span>
              <el-button
                type="primary"
                size="small"
                @click="openBioSlideSettingModal()"
                :disabled="!is_influencer_bio_slide.status || bio_slide_setting_modal"
              >
                <font-awesome-icon :icon="['fas', 'file-alt']" style="margin-right: 5px" />AI紹介スライド出力
              </el-button>
            </span>
          </el-tooltip>
        </div>
      </div>
    </div>
    <!-- ユーザーページ -->
    <div class="list-detail-page-wrap">
      <div class="list-breadcrumb-wrap" :class="header_area_stacked ? 'stacked' : ''" :style="'width:' + data_table_width">
        <div class="list-summary" ref="list_summary" :class="detail_loading || !mounted ? 'transparent' : ''">
          <div class="list-breadcrumb-image" @click="openImgDrawer()">
            <div class="i-detail-header-sns-type" :class="list_detail.sns_type">
              <svg v-if="list_detail.sns_type === 'twitter'" width="9" height="9" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
              </svg>
              <font-awesome-icon :icon="['fab', list_detail.sns_type]" v-else-if="list_detail.sns_type" />
            </div>
            <div class="list-breadcrumb-icon">
              <font-awesome-icon :icon="['fas', 'camera-alt']" />
            </div>
            <el-image :src="list_detail.img_url" class="data-table-profile list_img" fit="cover">
              <div slot="error" class="data-table-list-noimg">
                <font-awesome-icon :icon="['fal', 'list']" />
              </div>
            </el-image>
          </div>
          <div class="list-breacrumb-namearea">
            <div class="list-breadcrumb-name">
              <el-tooltip :content="list_detail.list_name" placement="top" :disabled="list_detail.list_name && list_detail.list_name.length < 18">
                <div class="list-breadcrumb-name-ellipsis">
                  {{ list_detail.list_name }}
                </div>
              </el-tooltip>
              <el-tooltip>
                <div slot="content">リスト名を変更</div>
                <i class="el-icon-edit pointer" style="color: #aaa; font-size: 14px; margin-left: 10px" @click="openChangeListName()" v-if="!list_detail.master"></i>
              </el-tooltip>
            </div>
            <div class="list-breadcrumb-description">
              <div>
                <span v-if="list_detail.target_client_name">{{ list_detail.target_client_name }}・</span>
                {{ list_detail.influencer_num }}名のインフルエンサー・{{ list_detail.followers_count | addComma }}フォロワー
              </div>
              <brandDropdown
                v-if="!list_detail.master"
                :id="list_detail.list_id"
                :list="list_detail"
                :target_client="client"
                :size="'small'"
                @changeTargetClient="changeTargetClient"
                @deleteClient="deleteClient"
              />
              <memberDropdown v-if="!list_detail.master" :id="list_detail.list_id" :list="list_detail" :size="'small'" @addMember="addMember" @deleteMember="deleteMember" />
              <tagDropdown v-if="!list_detail.master" :id="list_detail.list_id" :list="list_detail" :tag_list="tag_list" @addTag="addTag" @removeTag="removeTag" />
            </div>
          </div>
        </div>        
        <div class="list-detail-menu-wrap" ref="list_detail_menu">
          <el-tooltip
            v-if="influencer_update_label === 'updating' && influencer_updating_list.length"
            placement="bottom"
            effect="dark"
          >
            <div slot="content">
              <div v-for="item in influencer_updating_list" :key="item.sns + ':' + item.id">
                {{ item.account_name || item.id }}
              </div>
            </div>
            <div class="influencer-update-status updating">
              <span class="influencer-update-status-dot"></span>
              <span>
                更新中<span v-if="influencer_update_count > 0">({{ influencer_update_count }})</span>
              </span>
            </div>
          </el-tooltip>
          <div
            v-else-if="influencer_update_label === 'updating'"
            class="influencer-update-status updating"
          >
            <span class="influencer-update-status-dot"></span>
            <span>
              更新中<span v-if="influencer_update_count > 0">({{ influencer_update_count }})</span>
            </span>
          </div>
          <div class="recent-post-1month-checkbox" style="display:flex; align-items:center; gap:10px; margin-right:25px;">
            <el-checkbox v-model="has_recent_post_1month" @change="toggleRecentPost1Month">
              直近1ヶ月以内に投稿あり
            </el-checkbox>
          </div>
          <windowSwitch />
          <listDisplayButton :sns_type="list_detail.sns_type" :master="list_detail.master" :properties="properties" :property_loading="property_loading" />
          <el-button
            v-if="!list_detail.master && canAddCommentColumn"
            type="info"
            style="margin-right: 10px"
            @click="comment_add_dialog = true"
          >
            <font-awesome-icon :icon="['far', 'comment-alt']" style="margin-right: 5px" />コメント追加
          </el-button>
          <el-tooltip :disabled="export_influencer_list_enabled" v-if="!list_detail.master || admin_mode">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <span>
              <el-button type="info" :disabled="!export_influencer_list_enabled || list_detail.influencer_num == 0" @click="exportListDetail()">
                <font-awesome-icon :icon="['fas', 'cloud-download']" style="margin-right: 5px" />エクスポート
              </el-button>
            </span>
          </el-tooltip>
          <el-button icon="el-icon-user" style="margin-left: 10px" type="primary" @click="openAddInfluencer()" v-if="!list_detail.master">追加</el-button>
          <el-button icon="el-icon-plus" style="margin-left: 10px" type="info" @click="similarSearch()" v-if="list_detail.sns_type != 'youtube' && admin_mode && activate == 20">
            <div class="flex-row">
              類似
              <div class="loader--mini black" v-show="similar_loading"></div>
            </div>
          </el-button>
        </div>
      </div>

      <!-- テーブルタイトル -->
      <div v-if="(filtered || sort_keyword) && !influencer_loading" class="list-influencer-filtered-breadcrumb">
        <span class="report-influencer-breadcrumb-num">{{ result_count }}</span
        >名のインフルエンサー
      </div>

      <div class="data-table" :class="list_view_style">
        <div v-if="list_detail.sns_type == 'instagram'" class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account maxwidth">
            <!-- <div class="data-table-th-checkbox" v-if="!pagination">
              <input type="checkbox" class="checkbox-original" @change="checkAll()" v-model="checkAll_val" v-show="!noinfluencer" id="checkAll" />
              <label class="checkbox_inner" for="checkAll"> </label>
            </div> -->
            <div class="data-table-th-checkbox">
              <div class="checkbox_inner" :class="check_list_status" @click="checkAll_pagination('auto')"></div>
              <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
                <span style="height:20px">
                  <div class="checkbox-select-wrap" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="checkAll_pagination('select')">表示中を全て選択({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselect')">表示中を全て選択解除({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('selectAll')" divided v-if="!list_detail.master">
                    <span v-if="filtered && filtered_select_all">フィルターされたインフルエンサーを全て選択({{ filtered_select_all.length }}件)</span>
                    <span v-else>リスト内を全て選択({{ list_detail.select_all.length }}件)</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselectAll')" v-if="!list_detail.master && checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="data-table-th-picture_name data-table-th-line" id="item_account_name">ユーザー名</div>
          </div>
          <div class="data-table-th-140 data-table-th-line" id="item_personalized_name" v-show="item.personalized_name">
            <el-tooltip placement="top" content="設定することでDM一斉送信時に宛名をパーソナライズできるようになります。">
              <span>DM宛名<font-awesome-icon :icon="['fas', 'question-circle']"/></span>
            </el-tooltip>
          </div>
          <div class="data-table-th-140 data-table-th-line" id="item_personalized_price" v-show="item.personalized_price">
            <el-tooltip placement="top" content="設定することでDM一斉送信時に報酬金額をパーソナライズできるようになります。">
              <span>DM報酬金額<font-awesome-icon :icon="['fas', 'question-circle']"/></span>
            </el-tooltip>
          </div>
          <div class="data-table-th-dm data-table-th-line" id="item_dm">DM</div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <tableColumn :item="'age'" :column="'age'" :css="'usergender'" :title="'年齢'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-num data-table-th-line" v-if="item.age && admin_mode && activate == 20" id="item_age">生年月日候補</div>
          <div class="data-table-th-gender data-table-th-line" v-show="item.area" id="item_area">関連エリア</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">プロフィール</div>
          <tableColumn :item="'score'" :column="'score'" :css="'eg'" :title="'SCORE'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'followers'" :column="'followers_count'" :css="'num'" :title="'フォロワー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'following'" :column="'following_count'" :css="'num'" :title="'フォロー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'like_count'" :column="'average_like'" :css="'num'" :title="'平均いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'comments_count'" :column="'average_comments'" :css="'num'" :title="'平均コメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_count'" :column="'median_video_play_count'" :css="'num'" :title="'リール再生数中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_count_organic'" :column="'median_video_play_count_organic'" :css="'num'" :title="'リール再生数中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_count_pr'" :column="'median_video_play_count_pr'" :css="'num'" :title="'リール再生数中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_rate'" :column="'median_video_play_rate'" :css="'num'" :title="'リール視聴率中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_rate_organic'" :column="'median_video_play_rate_organic'" :css="'num'" :title="'リール視聴率中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_video_play_rate_pr'" :column="'median_video_play_rate_pr'" :css="'num'" :title="'リール視聴率中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'average_engagement_rate'" :css="'eg'" :title="'EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr_only_pr'" :column="'average_engagement_rate_only_pr'" :css="'eg'" :title="'EGR(PR投稿のみ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'pr_rate'" :column="'pr_rate'" :css="'eg'" :title="'PR率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-num" v-if="item.main_audience" id="item_main_audience">フォロワー<br />年齢層</div>
          <div class="data-table-th-tag data-table-th-line" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <tableColumn
            :item="'status'"
            :column="'status'"
            :css="'status data-table-list-status'"
            style="padding: 0 10px"
            v-show="!list_detail.master"
            :title="'ステータス'"
            :item_info="item_info"
            @sortBy="sortBy"
          />
          <div class="data-table-th-comment list-comment-table-column" id="item_comment" v-show="item.comment && !list_detail.master">
            <listCommentHeaderGroup
              :columns="comment_columns"
              :sort_key="sort_key"
              :sort_order="sort_order"
              :normalColumnCount="normalCommentColumnCount"
              @edit-title="openCommentTitleEdit"
              @delete-column="deleteCommentColumn"
              @sort-column="sortCommentColumn"
            />
          </div>
          <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name">
            {{ property.property }}
          </div>
          <div class="data-table-th-200" v-show="item.note" id="item_note">ノート</div>
          <tableColumn :item="'num'" :column="'num'" :css="'100'" :title="'数値'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'add_at'" :column="'add_at'" :css="'120'" :title="'リスト追加日'" v-show="!list_detail.master" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-photo data-table-th-line" v-if="item.recent_post" id="item_recent_post">{{ filter.post_keyword ? filter.post_keyword : "直近" }}の投稿</div>
          <div class="data-table-th-category" v-show="item.category" id="item_category">関連カテゴリ</div>
          <div class="data-table-th-person-title" v-show="item.person_title" id="item_category">人物・肩書</div>
          <div class="data-table-th-speciality-categories-genres" v-show="item.specialty_categories_genres" id="item_category">得意カテゴリー・ジャンル</div>
          <div class="data-table-th-post-format" v-show="item.post_format" id="item_category">投稿形式</div>
          
          <!-- レポート関連 -->
          <tableColumn :item="'report_count'" :column="'report_count'" :css="'num'" :title="'レポート\起用回数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_egr'" :column="'avg_report_egr'" :css="'eg'" :title="'レポート投稿平均EGR'" :item_info="item_info" @sortBy="sortBy" />          
          <tableColumn :item="'avg_report_reach_count'" :column="'avg_report_reach_count'" :css="'num'" :title="'レポート投稿平均リーチ数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_like_count'" :column="'avg_report_like_count'" :css="'num'" :title="'レポート投稿平均いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_comments_count'" :column="'avg_report_comments_count'" :css="'num'" :title="'レポート投稿平均コメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_saves_count'" :column="'avg_report_saves_count'" :css="'num'" :title="'レポート投稿平均保存数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'avg_report_cost'" :column="'avg_report_cost'" :css="'num'" :title="'レポート投稿平均コスト'" :item_info="item_info" @sortBy="sortBy" />
        </div>

        <!-- youtube -->
        <div v-if="list_detail.sns_type == 'youtube'" class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account maxwidth">
            <div class="data-table-th-checkbox">
              <div class="checkbox_inner" :class="check_list_status" @click="checkAll_pagination('auto')"></div>
              <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
                <span style="height:20px">
                  <div class="checkbox-select-wrap" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="checkAll_pagination('select')">表示中を全て選択({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselect')">表示中を全て選択解除({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('selectAll')" divided v-if="!list_detail.master">
                    <span v-if="filtered && filtered_select_all">フィルターされたインフルエンサーを全て選択({{ filtered_select_all.length }}件)</span>
                    <span v-else>リスト内を全て選択({{ list_detail.select_all.length }}件)</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselectAll')" v-if="!list_detail.master && checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="data-table-th-picture_name data-table-th-line" id="item_account_name">チャンネル名</div>
          </div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">チャンネル概要</div>
          <tableColumn :item="'subscriber'" :column="'subscriberCount'" :css="'num'" :title="'チャンネル\n登録者数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_viewRate_long_3month'" :column="'median_viewRate_long_3month'" :css="'eg'" :title="'視聴率中央値\n(長尺)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_viewRate_short_3month'" :column="'median_viewRate_short_3month'" :css="'eg'" :title="'視聴率中央値\n(ｼｮｰﾄ動画)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_viewCount_long_3month'" :column="'median_viewCount_long_3month'" :css="'num'" :title="'視聴回数中央値\n(長尺)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_viewCount_short_3month'" :column="'median_viewCount_short_3month'" :css="'num'" :title="'視聴回数中央値\n(ｼｮｰﾄ動画)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'average_engagementRate'" :css="'eg'" :title="'EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'comments_count'" :column="'average_comments_count'" :css="'eg'" :title="'平均\nコメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'frequency'" :column="'frequency'" :css="'eg'" :title="'投稿\n頻度'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'likeCount'" :column="'likeCount'" :css="'eg'" :title="'平均\n高評価数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'prRate_long_3month'" :column="'prRate_long_3month'" :css="'eg'" :title="'PR率\n(長尺)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'prRate_short_3month'" :column="'prRate_short_3month'" :css="'eg'" :title="'PR率\n(ｼｮｰﾄ動画)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-num" v-if="item.main_audience" id="item_main_audience">フォロワー<br />年齢層</div>
          <div class="data-table-th-tag data-table-th-line" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <tableColumn
            :item="'status'"
            :column="'status'"
            :css="'status data-table-list-status'"
            style="padding: 0 10px"
            v-show="!list_detail.master"
            :title="'ステータス'"
            :item_info="item_info"
            @sortBy="sortBy"
          />
          <div class="data-table-th-comment list-comment-table-column" id="item_comment" v-show="item.comment && !list_detail.master">
            <listCommentHeaderGroup
              :columns="comment_columns"
              :sort_key="sort_key"
              :sort_order="sort_order"
              :normalColumnCount="normalCommentColumnCount"
              @edit-title="openCommentTitleEdit"
              @delete-column="deleteCommentColumn"
              @sort-column="sortCommentColumn"
            />
          </div>
          <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name">
            {{ property.property }}
          </div>
          <div class="data-table-th-200" v-show="item.note" id="item_note">ノート</div>
          <tableColumn :item="'num'" :column="'num'" :css="'100'" :title="'数値'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'add_at'" :column="'add_at'" :css="'120'" :title="'リスト追加日'" v-show="!list_detail.master" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-photo youtube data-table-th-line" v-if="item.recent_post" id="item_recent_post">{{ filter.post_keyword ? filter.post_keyword : "直近" }}の投稿</div>
          <div class="data-table-th-category" v-show="item.category" id="item_category">関連カテゴリ</div>
        </div>

        <!-- tiktok -->
        <div v-if="list_detail.sns_type == 'tiktok'" class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account maxwidth">
            <div class="data-table-th-checkbox">
              <div class="checkbox_inner" :class="check_list_status" @click="checkAll_pagination('auto')"></div>
              <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
                <span style="height:20px">
                  <div class="checkbox-select-wrap" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="checkAll_pagination('select')">表示中を全て選択({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselect')">表示中を全て選択解除({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('selectAll')" divided v-if="!list_detail.master">
                    <span v-if="filtered && filtered_select_all">フィルターされたインフルエンサーを全て選択({{ filtered_select_all.length }}件)</span>
                    <span v-else>リスト内を全て選択({{ list_detail.select_all.length }}件)</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselectAll')" v-if="!list_detail.master && checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="data-table-th-picture_name data-table-th-line" id="item_account_name">ユーザー名</div>
          </div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">プロフィール概要</div>
          <tableColumn :item="'score'" :column="'score'" :css="'eg'" :title="'SCORE'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'subscriber'" :column="'followerCount'" :css="'num'" :title="'フォロワー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'heartCount'" :column="'heartCount'" :css="'num'" :title="'総いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playRate'" :column="'median_playRate'" :css="'eg'" :title="'視聴率中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playRate_organic'" :column="'median_playRate_organic'" :css="'eg'" :title="'視聴率中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playRate_pr'" :column="'median_playRate_pr'" :css="'eg'" :title="'視聴率中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playCount'" :column="'median_playCount'" :css="'num'" :title="'視聴回数中央値\n(合計)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playCount_organic'" :column="'median_playCount_organic'" :css="'num'" :title="'視聴回数中央値\n(ｵｰｶﾞﾆｯｸ)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'median_playCount_pr'" :column="'median_playCount_pr'" :css="'num'" :title="'視聴回数中央値\n(PR)'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'like_count'" :column="'diggCount'" :css="'num'" :title="'平均いいね数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'comments_count'" :column="'commentCount'" :css="'num'" :title="'平均コメント数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'share_count'" :column="'shareCount'" :css="'num'" :title="'平均シェア数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'engagementRate'" :css="'eg'" :title="'EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'pr_rate'" :column="'prRate'" :css="'eg'" :title="'PR率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'frequency'" :column="'media_frequency'" :css="'eg'" :title="'投稿\n頻度'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-tag data-table-th-line" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <tableColumn
            :item="'status'"
            :column="'status'"
            :css="'status data-table-list-status'"
            style="padding: 0 10px"
            v-show="!list_detail.master"
            :title="'ステータス'"
            :item_info="item_info"
            @sortBy="sortBy"
          />
          <div class="data-table-th-comment list-comment-table-column" id="item_comment" v-show="item.comment && !list_detail.master">
            <listCommentHeaderGroup
              :columns="comment_columns"
              :sort_key="sort_key"
              :sort_order="sort_order"
              :normalColumnCount="normalCommentColumnCount"
              @edit-title="openCommentTitleEdit"
              @delete-column="deleteCommentColumn"
              @sort-column="sortCommentColumn"
            />
          </div>
          <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name">
            {{ property.property }}
          </div>
          <div class="data-table-th-200" v-show="item.note" id="item_note">ノート</div>
          <tableColumn :item="'num'" :column="'num'" :css="'100'" :title="'数値'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'add_at'" :column="'add_at'" :css="'120'" :title="'リスト追加日'" v-show="!list_detail.master" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-photo data-table-th-line" v-if="item.recent_post_tt" id="item_recent_post">{{ filter.post_keyword ? filter.post_keyword : "直近" }}の投稿</div>
          <div class="data-table-th-category" v-show="item.category" id="item_category">関連カテゴリ</div>
        </div>

        <!-- twitter -->
        <div v-if="list_detail.sns_type == 'twitter'" class="data-table-th" :class="header_notification ? 'header-notification-space-120' : ''">
          <div class="data-table-th-background" :style="'width:' + data_table_width"></div>
          <div class="data-table-th-account maxwidth">
            <div class="data-table-th-checkbox">
              <div class="checkbox_inner" :class="check_list_status" @click="checkAll_pagination('auto')"></div>
              <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
                <span style="height:20px">
                  <div class="checkbox-select-wrap" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="checkAll_pagination('select')">表示中を全て選択({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselect')">表示中を全て選択解除({{ list.influencer ? list.influencer.length : "-" }}件)</el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('selectAll')" divided v-if="!list_detail.master">
                    <span v-if="filtered && filtered_select_all">フィルターされたインフルエンサーを全て選択({{ filtered_select_all.length }}件)</span>
                    <span v-else>リスト内を全て選択({{ list_detail.select_all.length }}件)</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="checkAll_pagination('unselectAll')" v-if="!list_detail.master && checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="data-table-th-picture_name data-table-th-line" id="item_account_name">ユーザー名</div>
          </div>
          <div class="data-table-th-sns data-table-th-line" v-show="item.sns" id="item_sns">SNS</div>
          <div class="data-table-th-usergender data-table-th-line" v-show="item.gender" id="item_gender">性別</div>
          <div class="data-table-th-bio data-table-th-line" v-show="item.bio" id="item_bio" :style="'max-width:' + max_width">プロフィール</div>
          <tableColumn :item="'followers'" :column="'followers_count'" :css="'num'" :title="'フォロワー数'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'like_count'" :column="'average_like_count'" :css="'num'" :title="'平均いいね'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'comments_count'" :column="'average_reply_count'" :css="'num'" :title="'平均コメント'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'retweet_count'" :column="'average_retweet_sum_count'" :css="'num'" :title="'平均リポスト'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'egr'" :column="'average_engagement_rate_tw'" :css="'eg'" :title="'EGR'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'pr_rate'" :column="'pr_rate'" :css="'eg'" :title="'PR率'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'frequency'" :column="'tweet_frequency'" :css="'eg'" :title="'投稿頻度'" :item_info="item_info" @sortBy="sortBy" />
          <!-- <tableColumn :item="'gender_ratio'" :column="'female_ratio'" :css="'gender'" :title="'フォロワー\n男女比'" :item_info="item_info" @sortBy="sortBy" /> -->
          <div class="data-table-th-tag data-table-th-line" v-show="item.tag" id="item_tag">カスタマイズタグ</div>
          <tableColumn
            :item="'status'"
            :column="'status'"
            :css="'status data-table-list-status'"
            style="padding: 0 10px"
            v-show="!list_detail.master"
            :title="'ステータス'"
            :item_info="item_info"
            @sortBy="sortBy"
          />
          <div class="data-table-th-comment list-comment-table-column" id="item_comment" v-show="item.comment && !list_detail.master">
            <listCommentHeaderGroup
              :columns="comment_columns"
              :sort_key="sort_key"
              :sort_order="sort_order"
              :normalColumnCount="normalCommentColumnCount"
              @edit-title="openCommentTitleEdit"
              @delete-column="deleteCommentColumn"
              @sort-column="sortCommentColumn"
            />
          </div>
          <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name">
            {{ property.property }}
          </div>
          <div class="data-table-th-200" v-show="item.note" id="item_note">ノート</div>
          <tableColumn :item="'num'" :column="'num'" :css="'100'" :title="'数値'" :item_info="item_info" @sortBy="sortBy" />
          <tableColumn :item="'add_at'" :column="'add_at'" :css="'120'" :title="'リスト追加日'" v-show="!list_detail.master" :item_info="item_info" @sortBy="sortBy" />
          <div class="data-table-th-photo data-table-th-line" v-if="item.recent_post" id="item_recent_post">{{ filter.post_keyword ? filter.post_keyword : "直近" }}の投稿</div>
          <div class="data-table-th-category" v-show="item.category" id="item_category">関連カテゴリ</div>
        </div>

        <!-- テーブルループ -->
        <div class="data-table-list-nolist" v-if="noinfluencer">
          <img src="../../assets/search_image.png" style="opacity: 0.5" alt />
          <div style="font-size: 20px; font-weight: 700; margin-bottom: 10px">インフルエンサーを追加しましょう</div>
          <div style="margin-bottom: 30px">インフルエンサー検索画面から追加できます</div>
          <div style="display: flex; flex-flow: row">
            <el-button type="primary" @click="toSearchPage">インフルエンサー検索</el-button>
            <el-button icon="el-icon-plus" type="primary" @click="openAddInfluencer()" v-if="!list_detail.master">インポート</el-button>
          </div>
        </div>
        <div class="data-table-list-nolist" v-else-if="notfound">
          <img src="../../assets/search_image.png" style="opacity: 0.5" alt />
          <div style="font-size: 20px; font-weight: 700; margin-bottom: 10px">インフルエンサーが見つかりませんでした</div>
          <div style="margin-bottom: 30px">条件やキーワードを変えて検索してみましょう</div>
        </div>

        <!-- instagram -->
        <div v-if="list_detail.sns_type == 'instagram'">
          <div class="data-table-tr total" v-if="!influencer_loading && !noinfluencer && !notfound">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox"></div>
              <div class="data-table-th-picture list"></div>
              <div class="data-table-th-account-name">
                <div style="font-weight: 700">Total/Average:</div>
              </div>
            </div>
            <div class="data-table-th-140" v-show="item.personalized_name"></div>
            <div class="data-table-th-140" v-show="item.personalized_price"></div>
            <div class="data-table-th-dm button"></div>
            <div class="data-table-th-sns" v-show="item.sns"></div>
            <div class="data-table-th-usergender" v-show="item.gender"></div>
            <div class="data-table-th-usergender" v-show="item.age"></div>
            <div class="data-table-th-num" v-if="item.age && admin_mode && activate == 20"></div>
            <div class="data-table-th-gender" v-show="item.area"></div>
            <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width"></div>
            <div class="data-table-th-eg" v-show="item.score">{{ filtered_total.score ? filtered_total.score : "-" }}</div>
            <div class="data-table-th-num" v-show="item.followers">{{ filtered_total.followers_count }}</div>
            <div class="data-table-th-num" v-show="item.following">{{ filtered_total.following_count }}</div>
            <div class="data-table-th-num" v-show="item.like_count">{{ filtered_total.like_count }}</div>
            <div class="data-table-th-num" v-show="item.comments_count">{{ filtered_total.comments_count }}</div>
            <div class="data-table-th-num" v-show="item.median_video_play_count">{{ filtered_total.median_video_play_count }}</div>
            <div class="data-table-th-num" v-show="item.median_video_play_count_organic">{{ filtered_total.median_video_play_count_organic }}</div>
            <div class="data-table-th-num" v-show="item.median_video_play_count_pr">{{ filtered_total.median_video_play_count_pr }}</div>
            <div class="data-table-th-num" v-show="item.median_video_play_rate">{{ filtered_total.median_video_play_rate }}%</div>
            <div class="data-table-th-num" v-show="item.median_video_play_rate_organic">{{ filtered_total.median_video_play_rate_organic }}%</div>
            <div class="data-table-th-num" v-show="item.median_video_play_rate_pr">{{ filtered_total.median_video_play_rate_pr }}%</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ filtered_total.average_engagement_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.egr_only_pr">{{ filtered_total.average_engagement_rate_only_pr ? filtered_total.average_engagement_rate_only_pr + "%" : "-" }}</div>
            <div class="data-table-th-eg" v-show="item.pr_rate">{{ filtered_total.pr_rate }}%</div>
            <div class="data-table-th-gender" v-show="item.gender_ratio">
              <el-tooltip placement="top">
                <div slot="content">女性:{{ filtered_total.female_ratio }}%&nbsp;&nbsp;男性:{{ filtered_total.male_ratio }}%</div>
                <div class="gender-bar-list" id="gender-list">
                  <div class="female-box-list" :style="'width:' + filtered_total.female_ratio + '%'"></div>
                  <div class="male-box-list" :style="'width:' + filtered_total.male_ratio + '%'"></div>
                </div>
              </el-tooltip>
            </div>
            <div class="data-table-th-num" v-show="item.main_audience"></div>
            <div class="data-table-th-tag" style="padding: 0px 10px" v-show="item.tag"></div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master"></div>
            <div class="data-table-th-comment list-comment-table-column" v-show="item.comment && !list_detail.master">
              <listCommentTotalCell v-if="item.comment && !list_detail.master" :columns="comment_columns" />
            </div>
            <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name"></div>
            <div class="data-table-th-200" v-show="item.note"></div>
            <div class="data-table-th-100 data-table-th-line" v-show="item.num"></div>
            <div class="data-table-th-120 data-table-th-line" v-show="item.add_at && !list_detail.master"></div>
            <div class="data-table-th-photo hover" v-show="item.recent_post && !search_keyword"></div>
            <div class="data-table-th-photo hover pointer" v-show="item.recent_post && search_keyword"></div>
            <div class="data-table-th-category" v-show="item.category"></div>
          </div>

          <div
            class="data-table-tr"
            v-for="(influencer, index) in list.influencer"
            :key="influencer.ig_id"
            v-show="influencer.list_id == list_id"
            :id="index"
            @mouseover="favorite_mouseover = index"
            @mouseleave="favorite_mouseover = ''"
          >
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox">
                <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.ig_id" :id="influencer.ig_id + 'checkbox'" />
                <label class="checkbox_inner" :for="influencer.ig_id + 'checkbox'"> </label>
              </div>
              <div class="data-table-th-picture list pointer">
                <favorite :favorite="influencer.favorite" :index="index" :referer="'list'" @changeFavorite="changeFavorite" />
                <stories :ig_id="influencer.ig_id" :stories.sync="influencer.stories" :index="index" :referer="'list'" />
                <img
                  @click.exact="window_switch ? openDrawer(influencer.account_name, index) : openNewWindow(influencer.account_name)"
                  @click.ctrl.exact="openNewWindow(influencer.account_name)"
                  @click.meta.exact="openNewWindow(influencer.account_name)"
                  :src="influencer.profile_picture_url"
                  class="data-table-profile list"
                  @error="imgError(index)"
                />
                <div
                  v-if="isInfluencerUpdating(influencer.ig_id)"
                  class="influencer-updating-avatar-badge"
                >更新中</div>
              </div>
              <div class="data-table-th-account-name pointer" id="item_tr_name">
                <div
                  @click.exact="window_switch ? openDrawer(influencer.account_name, index) : openNewWindow(influencer.account_name)"
                  @click.ctrl.exact="openNewWindow(influencer.account_name)"
                  @click.meta.exact="openNewWindow(influencer.account_name)"
                >
                  {{ influencer.account_name }}
                  <img src="../../assets/badge.png" style="width: 14px; height: 14px" v-show="influencer.badge == '1'" />
                </div>
                <div class="data-table-th-listname" v-if="list_detail.master ? influencer.list_count > 0 : influencer.list_count - 1 > 0">
                  <listIn
                    :list_in="influencer.list_in"
                    :list_count="influencer.list_count"
                    :referer="list_detail.master ? 'list_master' : 'list'"
                    :list_id="list_id"
                    :member_select="member_select"
                    v-show="permission.list.access"
                  />
                </div>
                <div class="data-table-th-listname" v-if="influencer.report_count > 0">
                  <reportIn
                    :report_in="influencer.report_in"
                    :report_count="influencer.report_count"
                    v-show="permission.report.access"
                  />
                </div>
              </div>
            </div>
            <div class="data-table-th-140" v-show="item.personalized_name">
              <comment
                :type="'personalized_name'"
                :personalized_name.sync="influencer.personalized_name"
                :id="influencer.ig_id"
                :list_id="list_id"
                :sns_type="list_detail.sns_type"
                :index="index"
                @syncComment="syncComment"
              />
            </div>
            <div class="data-table-th-140" v-show="item.personalized_price">
              <comment
                :type="'personalized_price'"
                :personalized_price.sync="influencer.personalized_price"
                :id="influencer.ig_id"
                :list_id="list_id"
                :sns_type="list_detail.sns_type"
                :index="index"
                @syncComment="syncComment"
              />
            </div>
            <div class="data-table-th-dm button">
              <el-tooltip :disabled="is_send_bulk_message.statusInbox">
                <div v-if="!is_send_bulk_message.statusInbox && is_send_bulk_message.message === ''" class="activate-popover" slot="content">
                  <div class="pointer" @click="toSetting">アップグレード</div>
                  でご利用いただけます
                </div>
                <div v-else-if="is_send_bulk_message.message !== ''" slot="content">
                  {{ is_send_bulk_message.message }}
                </div>
                <div class="list-dm-button" @click="is_send_bulk_message.statusInbox ? openMessageDrawer(influencer.ig_id) : null">
                  <font-awesome-icon :icon="['far', 'envelope']" />
                </div>
              </el-tooltip>
            </div>
            <div class="data-table-th-sns" v-show="item.sns">
              <snsIconList :other_sns="influencer.other_sns" />
            </div>
            <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
              <div class="pointer" @click="changeGender(influencer.ig_id, 'instagram', 'nodisplay', index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
              <div class="pointer" @click="changeGender(influencer.ig_id, 'instagram', '', index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
              <div class="pointer" @click="changeGender(influencer.ig_id, 'instagram', '女性', index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
              <div class="pointer" @click="changeGender(influencer.ig_id, 'instagram', '男性', index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
              <div class="pointer" @click="changeGender(influencer.ig_id, 'instagram', 'その他', index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
            </div>
            <div v-else>
              <div class="data-table-th-usergender" v-if="item.gender">{{ influencer.gender }}</div>
            </div>
            <div class="data-table-th-usergender" v-if="item.age">{{ influencer.age }}</div>
            <div class="data-table-th-num" v-if="item.age && admin_mode && activate == 20">
              <div class="data-table-birthday" @click="changeBirthday('', influencer.ig_id, index)">未設定</div>
              <div
                v-for="(birthday, birth_index) in influencer.pre_est_birthday"
                :key="birth_index"
                class="data-table-birthday"
                :class="[birthday.unlikely ? 'unlikely' : '', influencer.est_birthday == birthday.birthday ? 'active' : '']"
                @click="changeBirthday(birthday.birthday, influencer.ig_id, index)"
              >
                {{ birthday.birthday }}
              </div>
              <div v-if="influencer.pre_est_birthday" @click="(age_check = true), openDrawer(influencer.account_name, index, true)">Check</div>
              <div><a :href="'https://www.google.com/search?q=' + influencer.name + '+生年月日'" target="_blank">Google</a></div>
              <div @click="inputBirthday(influencer.ig_id, index)">手動入力</div>
            </div>
            <div class="data-table-th-gender" v-if="item.area">
              <div v-if="influencer.related_area">
                <font-awesome-icon icon="map-marker-alt" style="font-size: 12px; margin-right: 5px; color: #aaa" />
                <span v-for="area in influencer.related_area.area_data" :key="area.id" style="margin-right: 5px">{{ area.area_name }}</span>
              </div>
            </div>
            <div class="data-table-th-bio" v-if="item.bio" :style="'max-width:' + max_width">
              <pre><span class="bio-name">{{influencer.name}}</span><br />{{influencer.biography}}</pre>
            </div>
            <div class="data-table-th-eg" v-if="item.score" style="display: flex; flex-flow: row; align-items: center">
              <div class="score-icon" :class="influencer.score >= 80 ? 'excellent' : influencer.score >= 60 ? 'good' : influencer.score >= 40 ? 'average' : 'low'"></div>
              {{ influencer.score }}
            </div>
            <div class="data-table-th-num" v-if="item.followers">{{ influencer.followers }}</div>
            <div class="data-table-th-num" v-if="item.following">{{ influencer.following }}</div>
            <div class="data-table-th-num" v-if="item.like_count">{{ influencer.average_like }}</div>
            <div class="data-table-th-num" v-if="item.comments_count">{{ influencer.average_comments }}</div>
            <div class="data-table-th-num" v-if="item.median_video_play_count">{{ influencer.median_video_play_count ? influencer.median_video_play_count : 0 }}</div>
            <div class="data-table-th-num" v-if="item.median_video_play_count_organic">{{ influencer.median_video_play_count_organic ? influencer.median_video_play_count_organic : 0 }}</div>
            <div class="data-table-th-num" v-if="item.median_video_play_count_pr">{{ influencer.median_video_play_count_pr ? influencer.median_video_play_count_pr : 0 }}</div>
            <div class="data-table-th-num" v-if="item.median_video_play_rate">{{ influencer.median_video_play_rate ? influencer.median_video_play_rate : 0 }}%</div>
            <div class="data-table-th-num" v-if="item.median_video_play_rate_organic">{{ influencer.median_video_play_rate_organic ? influencer.median_video_play_rate_organic : 0 }}%</div>
            <div class="data-table-th-num" v-if="item.median_video_play_rate_pr">{{ influencer.median_video_play_rate_pr ? influencer.median_video_play_rate_pr : 0 }}%</div>
            <div class="data-table-th-eg" v-if="item.egr">{{ influencer.average_engagement_rate }}%</div>
            <div class="data-table-th-eg" v-if="item.egr_only_pr">{{ influencer.average_engagement_rate_only_pr > 0 ? influencer.average_engagement_rate_only_pr + "%" : "N/A" }}</div>
            <div class="data-table-th-eg" v-if="item.pr_rate">{{ influencer.pr_rate }}%</div>
            <div class="data-table-th-gender" v-if="item.gender_ratio">
              <genderRatio :female_ratio="influencer.female_ratio" :male_ratio="influencer.male_ratio" />
            </div>
            <div class="data-table-th-num" v-show="item.main_audience">
              <div v-if="influencer.main_audience">
                {{ influencer.main_audience }}<span class="data-table-main-audience-percent">{{ influencer.main_audience_percent }}%</span>
              </div>
              <div v-else>-</div>
            </div>
            <div class="data-table-th-tag" v-show="item.tag">
              <customizeTag :id="influencer.ig_id" :sns_type="'instagram'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
            </div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-if="item.status && !list_detail.master">
              <status :list_id="list_id" :sns_type="list_detail.sns_type" :id="influencer.ig_id" :status="influencer.status" :index="index" @syncStatus="syncStatus" />
            </div>
            <div class="data-table-th-comment list-comment-table-column" v-if="item.comment && !list_detail.master">
              <listCommentCells
                :columns="comment_columns"
                :influencer="influencer"
                :influencer_id="influencer.ig_id"
                :list_id="list_id"
                :sns_type="list_detail.sns_type"
                :index="index"
                @syncComment="syncComment"
              />
            </div>
            <div class="data-table-th-160 personal-data-th" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]">
              <noteInfo
                :id="influencer.ig_id"
                :sns_type="list_detail.sns_type"
                :property_id="property.property_id"
                :property="property.property"
                :info_content.sync="influencer.personal_data[property.property_name]"
                :index="index"
              />
            </div>
            <div class="data-table-th-200" v-show="item.note" style="flex-flow: column; align-items: flex-start">
              <pre v-for="(note, note_index) in influencer.note" :key="note_index">{{ note.content }}</pre>
            </div>
            <div class="data-table-th-100" v-if="item.num">
              <comment :type="'num'" :num.sync="influencer.num" :id="influencer.ig_id" :list_id="list_id" :sns_type="list_detail.sns_type" :index="index" @syncComment="syncComment" />
            </div>
            <div class="data-table-th-120" v-if="item.add_at && !list_detail.master">{{ influencer.add_at }}</div>
            <div
              class="data-table-th-photo hover"
              v-if="item.recent_post"
              @click="filter.post_keyword ? openDrawer(influencer.account_name, index, true) : ''"
              :class="filter.post_keyword ? 'pointer' : ''"
            >
              <div class="category">
                <div class="category-box-photoarea" v-for="(post, post_index) in influencer.recent_post" :key="post.id">
                  <img
                    :src="s3BaseUrl + '/postdata/' + post + '_s.jpg'"
                    class="category-box-img"
                    @error="imgErrorPost(index, post_index)"
                    :id="index + '-' + post_index"
                  />
                </div>
              </div>
            </div>
            <div class="data-table-th-category" v-if="item.category">
              <div class="category" id="item_category">
                <div class="category-box-list" v-for="category in influencer.category_arr.category_data" :key="category.id">
                  <font-awesome-icon icon="tag" style="margin-right: 3px" />
                  {{ category.category_name }}({{ category.category_ratio }}%)
                </div>
              </div>
            </div>
            <div class="data-table-th-person-title" v-if="item.person_title">
              <div class="attribute-wrap" id="item_attribute_person_title">
                <div class="attribute" v-for="person_title in influencer.person_title" :key="person_title.property_id">
                  {{ person_title.property_name }}
                </div>
              </div>
            </div>
            <div class="data-table-th-speciality-categories-genres" v-if="item.specialty_categories_genres">
              <div class="attribute-wrap" id="item_attribute_specialty_categories_genres">
                <div class="attribute" v-for="specialty_categories_genres in influencer.specialty_categories_genres" :key="specialty_categories_genres.property_id">
                  {{ specialty_categories_genres.property_name }}
                </div>
              </div>
            </div>
            <div class="data-table-th-post-format" v-if="item.post_format">
              <div class="attribute-wrap" id="item_attribute_post_format">
                <div class="attribute" v-for="post_format in influencer.post_format" :key="post_format.property_id">
                  {{ post_format.property_name }}
                </div>
              </div>
            </div>
                      
            <div class="data-table-th-num" v-show="item.report_count">{{ influencer.report_count }}</div>
            <div class="data-table-th-eg" v-show="item.avg_report_egr">{{ influencer.avg_report_egr }}%</div>
            <div class="data-table-th-num" v-show="item.avg_report_reach_count">{{ influencer.avg_report_reach_count }}</div>
            <div class="data-table-th-num" v-show="item.avg_report_like_count">{{ influencer.avg_report_like_count }}</div>
            <div class="data-table-th-num" v-show="item.avg_report_comments_count">{{ influencer.avg_report_comments_count }}</div>
            <div class="data-table-th-num" v-show="item.avg_report_saves_count">{{ influencer.avg_report_saves_count }}</div>
            <div class="data-table-th-num" v-show="item.avg_report_cost">{{ influencer.avg_report_cost }}</div>
                      
          </div>
        </div>

        <!-- youtube -->
        <div v-if="list_detail.sns_type == 'youtube'">
          <div class="data-table-tr total" v-if="!influencer_loading && !noinfluencer && !notfound">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox"></div>
              <div class="data-table-th-picture list"></div>
              <div class="data-table-th-account-name">
                <div style="font-weight: 700">Total/Average:</div>
              </div>
            </div>
            <div class="data-table-th-sns" v-show="item.sns"></div>
            <div class="data-table-th-usergender" v-show="item.gender"></div>
            <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width"></div>
            <div class="data-table-th-num" v-show="item.subscriber">{{ filtered_total.followers_count }}</div>
            <div class="data-table-th-eg" v-show="item.median_viewRate_long_3month">{{ filtered_total.median_view_rate_long != null ? filtered_total.median_view_rate_long + "%" : "-" }}</div>
            <div class="data-table-th-eg" v-show="item.median_viewRate_short_3month">{{ filtered_total.median_view_rate_short != null ? filtered_total.median_view_rate_short + "%" : "-" }}</div>
            <div class="data-table-th-num" v-show="item.median_viewCount_long_3month">{{ filtered_total.median_video_play_count_long != null ? filtered_total.median_video_play_count_long : "-" }}</div>
            <div class="data-table-th-num" v-show="item.median_viewCount_short_3month">{{ filtered_total.median_video_play_count_short != null ? filtered_total.median_video_play_count_short : "-" }}</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ filtered_total.average_engagement_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.comments_count">{{ filtered_total.comments_count }}</div>
            <div class="data-table-th-eg" v-show="item.frequency"></div>
            <div class="data-table-th-eg" v-show="item.likeCount">{{ filtered_total.like_count }}</div>
            <div class="data-table-th-eg" v-show="item.prRate_long_3month">{{ filtered_total.pr_rate_long != null ? filtered_total.pr_rate_long + "%" : "-" }}</div>
            <div class="data-table-th-eg" v-show="item.prRate_short_3month">{{ filtered_total.pr_rate_short != null ? filtered_total.pr_rate_short + "%" : "-" }}</div>
            <div class="data-table-th-gender" v-show="item.gender_ratio">
              <el-tooltip placement="top">
                <div slot="content">女性:{{ filtered_total.female_ratio }}%&nbsp;&nbsp;男性:{{ filtered_total.male_ratio }}%</div>
                <div class="gender-bar-list" id="gender-list">
                  <div class="female-box-list" :style="'width:' + filtered_total.female_ratio + '%'"></div>
                  <div class="male-box-list" :style="'width:' + filtered_total.male_ratio + '%'"></div>
                </div>
              </el-tooltip>
            </div>
            <div class="data-table-th-num" v-show="item.main_audience"></div>
            <div class="data-table-th-tag" style="padding: 0px 10px" v-show="item.tag"></div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master"></div>
            <div class="data-table-th-comment list-comment-table-column" v-show="item.comment && !list_detail.master">
              <listCommentTotalCell v-if="item.comment && !list_detail.master" :columns="comment_columns" />
            </div>
            <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name"></div>
            <div class="data-table-th-200" v-show="item.note"></div>
            <div class="data-table-th-100 data-table-th-line" v-show="item.num"></div>
            <div class="data-table-th-120 data-table-th-line" v-show="item.add_at && !list_detail.master"></div>
            <div class="data-table-th-photo youtube" v-show="item.recent_post && !search_keyword"></div>
            <div class="data-table-th-photo youtube" v-show="item.recent_post && search_keyword"></div>
          </div>
          <div class="data-table-tr" v-for="(influencer, index) in list.influencer" :key="influencer.id">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox">
                <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.channel_id" :id="influencer.channel_id + 'checkbox'" />
                <label class="checkbox_inner" :for="influencer.channel_id + 'checkbox'"> </label>
              </div>
              <div class="data-table-th-picture list pointer">
                <favorite :favorite="influencer.favorite" :index="index" :referer="'list'" @changeFavorite="changeFavorite" />
                <img
                  :src="influencer.thumbnails"
                  class="data-table-profile list"
                  @click.exact="window_switch ? openDrawer(influencer.channel_id, index) : openNewWindow(influencer.channel_id)"
                  @click.ctrl.exact="openNewWindow(influencer.channel_id)"
                  @click.meta.exact="openNewWindow(influencer.channel_id)"
                  @error="imgError(index)"
                />
                <div
                  v-if="isInfluencerUpdating(influencer.channel_id)"
                  class="influencer-updating-avatar-badge"
                >更新中</div>
              </div>
              <div class="data-table-th-account-name pointer" id="item_tr_name">
                <div
                  @click.exact="window_switch ? openDrawer(influencer.channel_id, index) : openNewWindow(influencer.channel_id)"
                  @click.ctrl.exact="openNewWindow(influencer.channel_id)"
                  @click.meta.exact="openNewWindow(influencer.channel_id)"
                  class="badge-wrap"
                >
                  {{ influencer.channel_name }}
                </div>
                <div class="data-table-th-listname" v-if="list_detail.master ? influencer.list_count > 0 : influencer.list_count - 1 > 0">
                  <listIn
                    :list_in="influencer.list_in"
                    :list_count="influencer.list_count"
                    :referer="list_detail.master ? 'list_master' : 'list'"
                    :list_id="list_id"
                    :member_select="member_select"
                    v-show="permission.list.access"
                  />
                </div>
              </div>
            </div>
            <div class="data-table-th-sns" v-show="item.sns">
              <snsIconList :other_sns="influencer.other_sns" />
            </div>
            <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
              <div class="pointer" @click="changeGender(influencer.channel_id, 'youtube', 'nodisplay', index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
              <div class="pointer" @click="changeGender(influencer.channel_id, 'youtube', '', index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
              <div class="pointer" @click="changeGender(influencer.channel_id, 'youtube', '女性', index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
              <div class="pointer" @click="changeGender(influencer.channel_id, 'youtube', '男性', index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
              <div class="pointer" @click="changeGender(influencer.channel_id, 'youtube', 'グループ', index)" :class="influencer.gender == 'グループ' ? 'active' : ''">グループ</div>
              <div class="pointer" @click="changeGender(influencer.channel_id, 'youtube', 'その他', index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
            </div>
            <div v-else>
              <div class="data-table-th-usergender" v-show="item.gender">{{ influencer.gender }}</div>
            </div>
            <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width">
              <pre>{{ influencer.description }}</pre>
            </div>
            <div class="data-table-th-num" v-show="item.subscriber">{{ influencer.hiddenSubscriberCount == 1 ? "非公開" : influencer.subscriberCount }}</div>
            <div class="data-table-th-eg" v-show="item.median_viewRate_long_3month">{{ influencer.hiddenSubscriberCount == 1 ? "-" : (influencer.median_viewRate_long_3month != null ? influencer.median_viewRate_long_3month + "%" : "-") }}</div>
            <div class="data-table-th-eg" v-show="item.median_viewRate_short_3month">{{ influencer.hiddenSubscriberCount == 1 ? "-" : (influencer.median_viewRate_short_3month != null ? influencer.median_viewRate_short_3month + "%" : "-") }}</div>
            <div class="data-table-th-num" v-show="item.median_viewCount_long_3month">{{ influencer.median_viewCount_long_3month != null ? influencer.median_viewCount_long_3month : "-" }}</div>
            <div class="data-table-th-num" v-show="item.median_viewCount_short_3month">{{ influencer.median_viewCount_short_3month != null ? influencer.median_viewCount_short_3month : "-" }}</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ influencer.hiddenSubscriberCount == 1 ? "-" : influencer.average_engagementRate_subscriber_3month + "%" }}</div>
            <div class="data-table-th-eg" v-show="item.comments_count">{{ influencer.average_commentCount_3month | addComma }}</div>
            <div class="data-table-th-eg" v-show="item.frequency">{{ influencer.average_postCount_week }}</div>
            <div class="data-table-th-eg" v-show="item.likeCount">{{ influencer.average_likeCount_3month | addComma  }}</div>
            <div class="data-table-th-eg" v-show="item.prRate_long_3month">{{ influencer.prRate_long_3month != null ? influencer.prRate_long_3month + "%" : "-" }}</div>
            <div class="data-table-th-eg" v-show="item.prRate_short_3month">{{ influencer.prRate_short_3month != null ? influencer.prRate_short_3month + "%" : "-" }}</div>
            <div class="data-table-th-gender" v-if="item.gender_ratio">
              <genderRatio :female_ratio="influencer.female_ratio" :male_ratio="influencer.male_ratio" />
            </div>
            <div class="data-table-th-num" v-show="item.main_audience">
              <div v-if="influencer.main_audience">
                {{ influencer.main_audience }}<span class="data-table-main-audience-percent">{{ influencer.main_audience_percent }}%</span>
              </div>
              <div v-else>-</div>
            </div>
            <div class="data-table-th-tag" v-show="item.tag">
              <customizeTag :id="influencer.channel_id" :sns_type="'youtube'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
            </div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master">
              <status :list_id="list_id" :sns_type="list_detail.sns_type" :id="influencer.channel_id" :status="influencer.status" :index="index" @syncStatus="syncStatus" />
            </div>
            <div class="data-table-th-comment list-comment-table-column" v-if="item.comment && !list_detail.master">
              <listCommentCells
                :columns="comment_columns"
                :influencer="influencer"
                :influencer_id="influencer.channel_id"
                :list_id="list_id"
                :sns_type="list_detail.sns_type"
                :index="index"
                @syncComment="syncComment"
              />
            </div>
            <div class="data-table-th-160 personal-data-th" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]">
              <!-- {{ influencer.personal_data[property.property_name] }} -->
              <noteInfo
                v-if="item[property.property_name]"
                :id="influencer.channel_id"
                :sns_type="list_detail.sns_type"
                :property_id="property.property_id"
                :property="property.property"
                :info_content.sync="influencer.personal_data[property.property_name]"
                :index="index"
              />
            </div>
            <div class="data-table-th-200" v-show="item.note" style="flex-flow: column; align-items: flex-start">
              <pre v-for="(note, note_index) in influencer.note" :key="note_index">{{ note.content }}</pre>
            </div>
            <div class="data-table-th-100" v-if="item.num">
              <comment :type="'num'" :num.sync="influencer.num" :id="influencer.channel_id" :list_id="list_id" :sns_type="list_detail.sns_type" :index="index" @syncComment="syncComment" />
            </div>
            <div class="data-table-th-120" v-if="item.add_at && !list_detail.master">
              {{ influencer.add_at }}
            </div>
            <div
              class="data-table-th-photo youtube hover"
              v-if="item.recent_post"
              @click="filter.post_keyword ? openDrawer(influencer.channel_id, index, true) : ''"
              :class="filter.post_keyword ? 'pointer' : ''"
            >
              <div class="category">
                <div class="category-box-photoarea youtube" v-for="video in influencer.recent_post" :key="video.id">
                  <img :src="'https://i.ytimg.com/vi/' + video + '/hqdefault.jpg'" alt class="category-box-img youtube" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- tiktok -->
        <div v-if="list_detail.sns_type == 'tiktok'">
          <div class="data-table-tr total" v-if="!influencer_loading && !noinfluencer && !notfound">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox"></div>
              <div class="data-table-th-picture list"></div>
              <div class="data-table-th-account-name">
                <div style="font-weight: 700">Total/Average:</div>
              </div>
            </div>
            <div class="data-table-th-sns" v-show="item.sns"></div>
            <div class="data-table-th-usergender" v-show="item.gender"></div>
            <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width"></div>
            <div class="data-table-th-eg" v-show="item.score">{{ filtered_total.score ? filtered_total.score : "-" }}</div>
            <div class="data-table-th-num" v-show="item.subscriber">{{ filtered_total.followers_count }}</div>
            <div class="data-table-th-num" v-show="item.heartCount">{{ filtered_total.heart_count }}</div>
            <div class="data-table-th-eg" v-show="item.median_playRate">{{ filtered_total.median_playRate }}%</div>
            <div class="data-table-th-eg" v-show="item.median_playRate_organic">{{ filtered_total.median_playRate_organic }}%</div>
            <div class="data-table-th-eg" v-show="item.median_playRate_pr">{{ filtered_total.median_playRate_pr }}%</div>
            <div class="data-table-th-num" v-show="item.median_playCount">{{ filtered_total.median_playCount }}</div>
            <div class="data-table-th-num" v-show="item.median_playCount_organic">{{ filtered_total.median_playCount_organic }}</div>
            <div class="data-table-th-num" v-show="item.median_playCount_pr">{{ filtered_total.median_playCount_pr }}</div>
            <div class="data-table-th-num" v-show="item.like_count">{{ filtered_total.like_count }}</div>
            <div class="data-table-th-num" v-show="item.comments_count">{{ filtered_total.comments_count }}</div>
            <div class="data-table-th-num" v-show="item.share_count">{{ filtered_total.share_count }}</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ filtered_total.average_engagement_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.pr_rate">{{ filtered_total.pr_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.frequency"></div>
            <div class="data-table-th-gender" v-show="item.gender_ratio">
              <el-tooltip placement="top">
                <div slot="content">女性:{{ filtered_total.female_ratio }}%&nbsp;&nbsp;男性:{{ filtered_total.male_ratio }}%</div>
                <div class="gender-bar-list" id="gender-list">
                  <div class="female-box-list" :style="'width:' + filtered_total.female_ratio + '%'"></div>
                  <div class="male-box-list" :style="'width:' + filtered_total.male_ratio + '%'"></div>
                </div>
              </el-tooltip>
            </div>
            <div class="data-table-th-tag" v-show="item.tag"></div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master"></div>
            <div class="data-table-th-comment list-comment-table-column" v-show="item.comment && !list_detail.master">
              <listCommentTotalCell v-if="item.comment && !list_detail.master" :columns="comment_columns" />
            </div>
            <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name"></div>
            <div class="data-table-th-200" v-show="item.note"></div>
            <div class="data-table-th-100 data-table-th-line" v-show="item.num"></div>
            <div class="data-table-th-120 data-table-th-line" v-show="item.add_at && !list_detail.master"></div>
            <div class="data-table-th-photo" v-show="item.recent_post_tt && !search_keyword"></div>
            <div class="data-table-th-photo" v-show="item.recent_post_tt && search_keyword"></div>
          </div>
          <div class="data-table-tr" v-for="(influencer, index) in list.influencer" :key="influencer.id">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox">
                <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.tt_id" :id="influencer.tt_id + 'checkbox'" />
                <label class="checkbox_inner" :for="influencer.tt_id + 'checkbox'"> </label>
              </div>
              <div class="data-table-th-picture list pointer">
                <favorite :favorite="influencer.favorite" :index="index" :referer="'list'" @changeFavorite="changeFavorite" />
                <img
                  :src="influencer.profile_picture_url"
                  class="data-table-profile list"
                  @click.exact="window_switch ? openDrawer(influencer.account_name, index) : openNewWindow(influencer.account_name)"
                  @click.ctrl.exact="openNewWindow(influencer.account_name)"
                  @click.meta.exact="openNewWindow(influencer.account_name)"
                  @error="imgError(index)"
                />
                <div
                  v-if="isInfluencerUpdating(influencer.tt_id)"
                  class="influencer-updating-avatar-badge"
                >更新中</div>
              </div>
              <div class="data-table-th-account-name youtube pointer" id="item_tr_name">
                <div
                  @click.exact="window_switch ? openDrawer(influencer.account_name, index) : openNewWindow(influencer.account_name)"
                  @click.ctrl.exact="openNewWindow(influencer.account_name)"
                  @click.meta.exact="openNewWindow(influencer.account_name)"
                  class="badge-wrap"
                >
                  {{ influencer.account_name }}
                  <font-awesome-icon :icon="['fas', 'check-circle']" v-show="influencer.verified" class="tt-badge" />
                </div>
                <div class="data-table-th-listname" v-if="list_detail.master ? influencer.list_count > 0 : influencer.list_count - 1 > 0">
                  <listIn
                    :list_in="influencer.list_in"
                    :list_count="influencer.list_count"
                    :referer="list_detail.master ? 'list_master' : 'list'"
                    :list_id="list_id"
                    :member_select="member_select"
                    v-show="permission.list.access"
                  />
                </div>
              </div>
            </div>
            <div class="data-table-th-sns" v-show="item.sns">
              <snsIconList :other_sns="influencer.other_sns" />
            </div>
            <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
              <div class="pointer" @click="changeGender(influencer.tt_id, 'tiktok', 'nodisplay', index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
              <div class="pointer" @click="changeGender(influencer.tt_id, 'tiktok', '', index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
              <div class="pointer" @click="changeGender(influencer.tt_id, 'tiktok', '女性', index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
              <div class="pointer" @click="changeGender(influencer.tt_id, 'tiktok', '男性', index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
              <div class="pointer" @click="changeGender(influencer.tt_id, 'tiktok', 'グループ', index)" :class="influencer.gender == 'グループ' ? 'active' : ''">グループ</div>
              <div class="pointer" @click="changeGender(influencer.tt_id, 'tiktok', 'その他', index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
            </div>
            <div v-else>
              <div class="data-table-th-usergender" v-show="item.gender">{{ influencer.gender }}</div>
            </div>
            <div class="data-table-th-bio" v-if="item.bio" :style="'max-width:' + max_width">
              <pre><span class="bio-name">{{influencer.nickname}}</span><br />{{influencer.signature}}</pre>
            </div>
            <div class="data-table-th-eg" v-if="item.score" style="display: flex; flex-flow: row; align-items: center">
              <div class="score-icon" :class="influencer.score >= 80 ? 'excellent' : influencer.score >= 60 ? 'good' : influencer.score >= 40 ? 'average' : 'low'"></div>
              {{ influencer.score }}
            </div>
            <div class="data-table-th-num" v-show="item.subscriber">{{ influencer.followerCount }}</div>
            <div class="data-table-th-num" v-show="item.heartCount">{{ influencer.heartCount }}</div>
            <div class="data-table-th-eg" v-show="item.median_playRate">{{ influencer.median_playRate }}%</div>
            <div class="data-table-th-eg" v-show="item.median_playRate_organic">{{ influencer.median_playRate_organic }}%</div>
            <div class="data-table-th-eg" v-show="item.median_playRate_pr">{{ influencer.median_playRate_pr }}%</div>
            <div class="data-table-th-num" v-show="item.median_playCount">{{ influencer.median_playCount | addComma }}</div>
            <div class="data-table-th-num" v-show="item.median_playCount_organic">{{ influencer.median_playCount_organic | addComma }}</div>
            <div class="data-table-th-num" v-show="item.median_playCount_pr">{{ influencer.median_playCount_pr | addComma }}</div>
            <div class="data-table-th-num" v-show="item.like_count">{{ influencer.diggCount }}</div>
            <div class="data-table-th-num" v-show="item.comments_count">{{ influencer.commentCount }}</div>
            <div class="data-table-th-num" v-show="item.share_count">{{ influencer.shareCount }}</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ influencer.engagementRate + "%" }}</div>
            <div class="data-table-th-eg" v-show="item.pr_rate">{{ influencer.prRate }}%</div>
            <div class="data-table-th-eg" v-show="item.frequency">{{ influencer.media_frequency }}</div>
            <div class="data-table-th-gender" v-if="item.gender_ratio">
              <genderRatio :female_ratio="influencer.female_ratio" :male_ratio="influencer.male_ratio" />
            </div>
            <!-- <div class="data-table-th-num" v-show="item.main_audience">
              <div v-if="influencer.main_audience">
                {{ influencer.main_audience }}<span class="data-table-main-audience-percent">{{ influencer.main_audience_percent }}%</span>
              </div>
              <div v-else>-</div>
            </div> -->
            <div class="data-table-th-tag" v-show="item.tag">
              <customizeTag :id="influencer.tt_id" :sns_type="'tiktok'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
            </div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master">
              <status :list_id="list_id" :sns_type="list_detail.sns_type" :id="influencer.tt_id" :status="influencer.status" :index="index" @syncStatus="syncStatus" />
            </div>
            <div class="data-table-th-comment list-comment-table-column" v-if="item.comment && !list_detail.master">
              <listCommentCells
                :columns="comment_columns"
                :influencer="influencer"
                :influencer_id="influencer.tt_id"
                :list_id="list_id"
                :sns_type="list_detail.sns_type"
                :index="index"
                @syncComment="syncComment"
              />
            </div>
            <div class="data-table-th-160 personal-data-th" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]">
              <noteInfo
                :id="influencer.tt_id"
                :sns_type="list_detail.sns_type"
                :property_id="property.property_id"
                :property="property.property"
                :info_content.sync="influencer.personal_data[property.property_name]"
                :index="index"
              />
            </div>
            <div class="data-table-th-200" v-show="item.note" style="flex-flow: column; align-items: flex-start">
              <pre v-for="(note, note_index) in influencer.note" :key="note_index">{{ note.content }}</pre>
            </div>
            <div class="data-table-th-100" v-if="item.num">
              <comment :type="'num'" :num.sync="influencer.num" :id="influencer.tt_id" :list_id="list_id" :sns_type="list_detail.sns_type" :index="index" @syncComment="syncComment" />
            </div>
            <div class="data-table-th-120" v-if="item.add_at && !list_detail.master">
              {{ influencer.add_at }}
            </div>
            <div
              class="data-table-th-photo hover"
              v-if="item.recent_post_tt"
              @click="filter.post_keyword ? openDrawer(influencer.account_name, index, true) : ''"
              :class="filter.post_keyword ? 'pointer' : ''"
            >
              <div class="category">
                <div class="category-box-photoarea tiktok" v-for="(post, post_index) in influencer.recent_post" :key="post.id">
                  <img
                    :src="s3BaseUrl + '/tt_postdata/' + post + '_s.jpg'"
                    class="category-box-img"
                    @error="imgErrorPost(index, post_index)"
                    :id="index + '-' + post_index"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- twitter -->
        <div v-if="list_detail.sns_type == 'twitter'">
          <div class="data-table-tr total" v-if="!influencer_loading && !noinfluencer && !notfound">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox"></div>
              <div class="data-table-th-picture list"></div>
              <div class="data-table-th-account-name">
                <div style="font-weight: 700">Total/Average:</div>
              </div>
            </div>
            <div class="data-table-th-sns" v-show="item.sns"></div>
            <div class="data-table-th-usergender" v-show="item.gender"></div>
            <div class="data-table-th-bio" v-show="item.bio" :style="'max-width:' + max_width"></div>
            <div class="data-table-th-num" v-show="item.followers">{{ filtered_total.followers_count }}</div>
            <div class="data-table-th-num" v-show="item.like_count">{{ filtered_total.like_count }}</div>
            <div class="data-table-th-num" v-show="item.comments_count">{{ filtered_total.comments_count }}</div>
            <div class="data-table-th-num" v-show="item.retweet_count">{{ filtered_total.retweet_count }}</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ filtered_total.average_engagement_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.pr_rate">{{ filtered_total.pr_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.frequency"></div>
            <!-- <div class="data-table-th-gender" v-show="item.gender_ratio">
              <el-tooltip placement="top">
                <div slot="content">女性:{{ filtered_total.female_ratio }}%&nbsp;&nbsp;男性:{{ filtered_total.male_ratio }}%</div>
                <div class="gender-bar-list" id="gender-list">
                  <div class="female-box-list" :style="'width:' + filtered_total.female_ratio + '%'"></div>
                  <div class="male-box-list" :style="'width:' + filtered_total.male_ratio + '%'"></div>
                </div>
              </el-tooltip>
            </div> -->
            <div class="data-table-th-tag" v-show="item.tag"></div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master"></div>
            <div class="data-table-th-comment list-comment-table-column" v-show="item.comment && !list_detail.master">
              <listCommentTotalCell v-if="item.comment && !list_detail.master" :columns="comment_columns" />
            </div>
            <div class="data-table-th-160" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]" :id="'item_personal_' + property.property_name"></div>
            <div class="data-table-th-200" v-show="item.note"></div>
            <div class="data-table-th-100 data-table-th-line" v-show="item.num"></div>
            <div class="data-table-th-120 data-table-th-line" v-show="item.add_at && !list_detail.master"></div>
            <div class="data-table-th-photo" v-show="item.recent_post && !search_keyword"></div>
            <div class="data-table-th-photo" v-show="item.recent_post && search_keyword"></div>
          </div>
          <div class="data-table-tr" v-for="(influencer, index) in list.influencer" :key="influencer.id">
            <div class="data-table-tr-background" :style="'width:' + data_table_width"></div>
            <div class="data-table-th-account maxwidth">
              <div class="data-table-th-checkbox">
                <input type="checkbox" class="checkbox-original" v-model="checkList" :value="influencer.tw_id" :id="influencer.tw_id + 'checkbox'" />
                <label class="checkbox_inner" :for="influencer.tw_id + 'checkbox'"> </label>
              </div>
              <div class="data-table-th-picture list pointer">
                <favorite :favorite="influencer.favorite" :index="index" :referer="'list'" @changeFavorite="changeFavorite" />
                <img
                  :src="influencer.profile_image_url"
                  class="data-table-profile list"
                  @click.exact="window_switch ? openDrawer(influencer.account_name, index) : openNewWindow(influencer.account_name)"
                  @click.ctrl.exact="openNewWindow(influencer.account_name)"
                  @click.meta.exact="openNewWindow(influencer.account_name)"
                  @error="imgError(index)"
                />
                <div
                  v-if="isInfluencerUpdating(influencer.tw_id)"
                  class="influencer-updating-avatar-badge"
                >更新中</div>
              </div>
              <div class="data-table-th-account-name youtube pointer" id="item_tr_name">
                <div
                  @click.exact="window_switch ? openDrawer(influencer.account_name, index) : openNewWindow(influencer.account_name)"
                  @click.ctrl.exact="openNewWindow(influencer.account_name)"
                  @click.meta.exact="openNewWindow(influencer.account_name)"
                  class="badge-wrap"
                >
                  {{ influencer.account_name }}
                  <font-awesome-icon :icon="['fas', 'badge-check']" v-show="influencer.verified" class="tw-badge" />
                </div>
                <div class="data-table-th-listname" v-if="list_detail.master ? influencer.list_count > 0 : influencer.list_count - 1 > 0">
                  <listIn
                    :list_in="influencer.list_in"
                    :list_count="influencer.list_count"
                    :referer="list_detail.master ? 'list_master' : 'list'"
                    :list_id="list_id"
                    :member_select="member_select"
                    v-show="permission.list.access"
                  />
                </div>
              </div>
            </div>
            <div class="data-table-th-sns" v-show="item.sns">
              <snsIconList :other_sns="influencer.other_sns" />
            </div>
            <div class="data-table-th-usergender" v-if="item.gender && activate == 20 && admin_mode">
              <div class="pointer" @click="changeGender(influencer.tw_id, 'twitter', 'nodisplay', index)" :class="influencer.gender == 'nodisplay' ? 'danger' : ''">非表示</div>
              <div class="pointer" @click="changeGender(influencer.tw_id, 'twitter', '', index)" :class="influencer.gender == '' ? 'active null' : ''">未設定</div>
              <div class="pointer" @click="changeGender(influencer.tw_id, 'twitter', '女性', index)" :class="influencer.gender == '女性' ? 'active' : ''">女性</div>
              <div class="pointer" @click="changeGender(influencer.tw_id, 'twitter', '男性', index)" :class="influencer.gender == '男性' ? 'active' : ''">男性</div>
              <div class="pointer" @click="changeGender(influencer.tw_id, 'twitter', 'グループ', index)" :class="influencer.gender == 'グループ' ? 'active' : ''">グループ</div>
              <div class="pointer" @click="changeGender(influencer.tw_id, 'twitter', 'その他', index)" :class="influencer.gender == 'その他' ? 'active' : ''">その他</div>
            </div>
            <div v-else>
              <div class="data-table-th-usergender" v-show="item.gender">{{ influencer.gender }}</div>
            </div>
            <div class="data-table-th-bio" v-if="item.bio" :style="'max-width:' + max_width">
              <pre><span class="bio-name">{{influencer.name}}</span><br />{{influencer.description}}</pre>
            </div>
            <div class="data-table-th-num" v-show="item.followers">{{ influencer.followers_count }}</div>
            <div class="data-table-th-num" v-show="item.like_count">{{ influencer.average_like_count }}</div>
            <div class="data-table-th-num" v-show="item.comments_count">{{ influencer.average_reply_count }}</div>
            <div class="data-table-th-num" v-show="item.retweet_count">{{ influencer.average_retweet_sum_count }}</div>
            <div class="data-table-th-eg" v-show="item.egr">{{ influencer.average_engagement_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.pr_rate">{{ influencer.pr_rate }}%</div>
            <div class="data-table-th-eg" v-show="item.frequency">{{ influencer.tweet_frequency }}/週</div>
            <!-- <div class="data-table-th-num" v-show="item.main_audience">
              <div v-if="influencer.main_audience">
                {{ influencer.main_audience }}<span class="data-table-main-audience-percent">{{ influencer.main_audience_percent }}%</span>
              </div>
              <div v-else>-</div>
            </div> -->
            <div class="data-table-th-tag" v-show="item.tag">
              <customizeTag :id="influencer.tw_id" :sns_type="'tiktok'" :tags="influencer.tags" :influencer_index="index" @updateTag="updateTag" />
            </div>
            <div class="data-table-list-status" style="padding: 0px 10px" v-show="item.status && !list_detail.master">
              <status :list_id="list_id" :sns_type="list_detail.sns_type" :id="influencer.tw_id" :status="influencer.status" :index="index" @syncStatus="syncStatus" />
            </div>
            <div class="data-table-th-comment list-comment-table-column" v-if="item.comment && !list_detail.master">
              <listCommentCells
                :columns="comment_columns"
                :influencer="influencer"
                :influencer_id="influencer.tw_id"
                :list_id="list_id"
                :sns_type="list_detail.sns_type"
                :index="index"
                @syncComment="syncComment"
              />
            </div>
            <div class="data-table-th-160 personal-data-th" v-for="property in properties" :key="property.property_id" v-show="item[property.property_name]">
              <noteInfo
                :id="influencer.tw_id"
                :sns_type="list_detail.sns_type"
                :property_id="property.property_id"
                :property="property.property"
                :info_content.sync="influencer.personal_data[property.property_name]"
                :index="index"
              />
            </div>
            <div class="data-table-th-200" v-show="item.note" style="flex-flow: column; align-items: flex-start">
              <pre v-for="(note, note_index) in influencer.note" :key="note_index">{{ note.content }}</pre>
            </div>
            <div class="data-table-th-100" v-if="item.num">
              <comment :type="'num'" :num.sync="influencer.num" :id="influencer.tw_id" :list_id="list_id" :sns_type="list_detail.sns_type" :index="index" @syncComment="syncComment" />
            </div>
            <div class="data-table-th-120" v-if="item.add_at && !list_detail.master">
              {{ influencer.add_at }}
            </div>
            <div
              class="data-table-th-photo hover"
              v-if="item.recent_post"
              @click="filter.post_keyword ? openDrawer(influencer.account_name, index, true) : ''"
              :class="filter.post_keyword ? 'pointer' : ''"
            >
              <div class="category">
                <div class="category-box-photoarea" v-for="(post, post_index) in influencer.recent_post" :key="post">
                  <img :src="post + '?name=120x120'" class="category-box-img" @error="imgErrorPost(index, post_index)" :id="index + '-' + post_index" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Nation -->
      <div class="list-detail-pagination" v-if="list_view_style == 'pagination'">
        <el-pagination small background layout="prev, pager, next" :total="result_count" @current-change="pageChange()" :current-page.sync="current_page" :page-size="limit"></el-pagination>
        <el-select class="list-detail-pagination-limit-select" size="nano" v-model="limit" @change="limitChange()">
          <el-option label="20件" :value="20"></el-option>
          <el-option label="50件" :value="50"></el-option>
          <el-option label="100件" :value="100"></el-option>
        </el-select>
        <!-- <el-dropdown trigger="click">
          <el-button size="mini">{{limit}}件
            <font-awesome-icon icon="caret-down" style="margin-left:3px" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="limitChange(20)">20件</el-dropdown-item>
            <el-dropdown-item @click.native="limitChange(50)">50件</el-dropdown-item>
            <el-dropdown-item @click.native="limitChange(100)">100件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <el-tooltip content="縦スクロールタイプの従前のリストビューに戻します">
          <div @click="changeListView('scroll')" class="router-link small" style="margin-left:20px; font-weight:700">元のリストビューに戻す</div>
        </el-tooltip>
      </div>

      <!-- infinite -->
      <infinite-loading v-if="list_view_style == 'pagination'" spinner="spiral" :identifier="infiniteId" @infinite="loadInfluencer">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>

      <infinite-loading v-else spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>

      <!-- drawer -->
      <div :class="[drawer ? 'i-detail-modal open' : 'i-detail-modal', printmode ? 'print' : '']" id="i-detail-scroll">
        <router-view
          ref="iDetail"
          v-show="drawer"
          @loadFromDetail="loadFromDetail"
          @favoriteReactive="favoriteReactive"
          @addInfluencerReactive="addInfluencerReactive"
          @deleteInfluencerReactive="deleteInfluencerReactive"
          @commentReactive="commentReactive"
          @statusReactive="statusReactive"
          @noteReactive="noteReactive"
          @tagReactive="tagReactive"
        ></router-view>
      </div>
      <div class="overlay" :class="[drawer ? 'overlay open' : 'overlay']" @click="closeDrawer()"></div>

      <!-- 新規メッセージ作成 -->
      <transition name="fade">
        <newmessage
          v-if="newmessage_drawer"
          :newmessage_drawer.sync="newmessage_drawer"
          :message_drawer="message_drawer"
          :recipient="checkListDetail"
          :checkList.sync="checkList"
          :html.sync="html"
          @closeNewmessage="closeNewmessage()"
          @clearList="clearList()"
        />
      </transition>

      <!-- メッセージ -->
      <div class="overlay-sub" :class="[message_drawer ? 'overlay open' : 'overlay']" @click="closeMessageDrawer()"></div>
      <div :class="[message_drawer ? 'pr-detail-modal open' : 'pr-detail-modal']">
        <inboxDetail v-if="message_drawer" :ig_id="dm_ig_id" referer="idetail" />
      </div>

      <!-- リスト追加 -->
      <listImport
        :add_influencer_modal.sync="add_influencer_modal"
        :list_id="list_id"
        :list_name="list_detail.list_name"
        :sns_type="list_detail.sns_type"
        @loadQuery="loadQuery"
        @loadList="loadList"
        @loadListDetail="loadListDetail"
        @refreshInfluencerUpdateStatus="refreshInfluencerUpdateStatus"
      />

      <!-- imgChange -->
      <el-dialog title="リストイメージ画像の変更" :visible.sync="img_change" width="420px" top="20vh">
        <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" :limit="1" :file-list="fileList" action>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            画像をドロップ
            <em>もしくは選択してアップロードしてください</em>
          </div>
          <div class="el-upload__tip" slot="tip">推奨ファイル:500kb以下のjpg/png形式</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(img_change = false), (fileList = [])">キャンセル</el-button>
          <el-button type="primary" @click="imgUpload">変更</el-button>
        </span>
      </el-dialog>

      <!-- editInfluencer -->
      <editInfluencer
        :checkList.sync="checkList"
        :edit_drawer.sync="edit_drawer"
        :list_id="list_id"
        :sns_type="list_detail.sns_type"
        :comment_columns="comment_columns"
        @closeEditDrawer="closeEditDrawer"
        @editBulkUpdate="editBulkUpdate"
      />

      <listCommentAddDialog
        :visible.sync="comment_add_dialog"
        :list_id="list_id"
        :comment_columns="comment_columns"
        @added="onCommentColumnAdded"
      />

      <!-- listmenu -->
      <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
      <div class="list-detail-sidemenu" :class="dark_mode ? 'dark' : ''">
        <div class="router-push">
          <div :class="isOem ? 'logo-wrap-oem' : 'logo-wrap'">
            <img :src="[dark_mode ? darkLogo : logo]" :class="isOem ? 'logo-oem' : 'logo'" @click="routerPush('/')" />
            <p v-show="!isOem" :class="[dark_mode ? 'logofont dark' : 'logofont']">{{logoText}}</p>
          </div>
        </div>       
        <div class="list-detail-sidemenu-button">
          <router-link to="/list">
            <el-button size="small" style="width: 100%; margin-top:5px" type="info">
              <font-awesome-icon :icon="['far', 'arrow-left']" style="margin-right: 3px;" />
              リスト一覧に戻る</el-button
            >
          </router-link>
          <div style="margin-top:15px"></div>
          <div class="flex-row" style="margin-bottom:5px">
            <el-input
              v-model="list_search_word"
              @input="searchList()"
              placeholder="リスト名で検索"
              :trigger-on-focus="false"
              :class="dark_mode ? 'dark' : ''"
              clearable
              size="small"
              style="width:135px"
            >
            </el-input>
            <el-dropdown trigger="click" placement="bottom-start">
              <div class="list-detail-side-member-wrap-button --80px  pointer" :class="list_sns_type != 'all' ? 'select' : ''">
                <div class="list-detail-side-member">
                  <svg v-if="list_sns_type === 'twitter' && list_sns_type != 'all' && list_sns_type != 'master'" width="9" height="9" viewBox="0 0 1200 1227" style="margin-right: 5px" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                  </svg>                
                  <font-awesome-icon :icon="['fab', list_sns_type]" v-if="list_sns_type != 'twitter' && list_sns_type != 'all' && list_sns_type != 'master'" style="margin-right: 5px;" />                  
                  <span class="list-detail-side-member-name noellipsis">
                    {{ list_sns_name }}
                  </span>
                  <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="sns in sns_list" :key="sns.name" @click.native="selectSNS(sns)">
                  <svg v-if="sns.value === 'twitter' && sns.value != 'all' && sns.value != 'master'" width="9" height="9" viewBox="0 0 1200 1227" style="margin-right: 5px" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
                  </svg>
                  <font-awesome-icon :icon="['fab', sns.value]" v-if="sns.value != 'twitter' && sns.value != 'all' && sns.value != 'master'" style="margin-right: 5px;" />
                  {{ sns.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="list-detail-side-member-wrap" v-if="(activate >= 15 || activate == 11) && list_sns_type != 'master'">
            <el-dropdown trigger="click" placement="bottom-start">
              <div class="list-detail-side-member-wrap-button pointer" :class="client_select != '' && client_select.target_client_id != 'all' ? 'select' : ''">
                <div v-if="client_select == '' || client_select.target_client_id == 'all'">
                  全てのブランド
                  <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
                </div>
                <div class="list-detail-side-member" v-else>
                  <el-image :src="client_select.img_url" class="list-member-profile-sidemenu">
                    <div slot="error" class="list-member-noimg sidemenu">
                      {{ client_select.target_client_name | firstLetter }}
                    </div>
                  </el-image>
                  <span class="list-detail-side-member-name">
                    {{ client_select.target_client_name }}
                  </span>
                  <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="selectClient(all_client)">全てのブランド</el-dropdown-item>
                <el-dropdown-item v-for="client in client" :key="client.id" class="member" @click.native="selectClient(client)">
                  <el-image :src="client.img_url" class="list-member-profile dropdown">
                    <div slot="error" class="list-member-noimg sidemenu">
                      {{ client.target_client_name | firstLetter }}
                    </div>
                  </el-image>
                  <div class="list-member-dropdown-namearea">
                    <div>{{ client.target_client_name }}</div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown trigger="click" placement="bottom-start">
              <div class="list-detail-side-member-wrap-button pointer" :class="member_select != '' && member_select.person_id != 'all' ? 'select' : ''">
                <div v-if="member_select == '' || member_select.person_id == 'all'">
                  全てのメンバー
                  <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
                </div>
                <div class="list-detail-side-member" v-else>
                  <el-image :src="member_select.img_url" class="list-member-profile-sidemenu">
                    <div slot="error" class="list-member-noimg sidemenu">
                      {{ member_select.person_name | firstLetter }}
                    </div>
                  </el-image>
                  <span class="list-detail-side-member-name">
                    {{ member_select.person_name }}
                  </span>
                  <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="selectMember(all_member)">全てのメンバー</el-dropdown-item>
                <el-dropdown-item v-for="member in member" :key="member.id" class="member" @click.native="selectMember(member)">
                  <el-image :src="member.img_url" class="list-member-profile dropdown">
                    <div slot="error" class="list-member-noimg sidemenu">
                      {{ member.person_name | firstLetter }}
                    </div>
                  </el-image>
                  <div class="list-member-dropdown-namearea">
                    <div>{{ member.person_name }}</div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="list-detail-sidemenu-tr-wrap" id="sidemenu-wrap" @mouseover="mouseoverSidemenu()" @mouseleave="mouseleaveSidemenu()">
          <div class="list-detail-sidemenu-loading" v-loading="list_loading" v-if="list_loading"></div>
          <div v-else-if="list_count > 0">
            <div
              v-for="list in list_data"
              :key="list.id"
              class="list-detail-sidemenu-tr"
              :class="[list_id == list.list_id ? 'list-active' : '', influencer_loading ? '' : '', dark_mode ? 'dark' : '']"
              @click="listOpen(list.list_id)"
              :id="list.list_id"
            >
              <div class="list-detail-name">
                <svg v-if="list.sns_type === 'twitter'" width="9" height="9" viewBox="0 0 1200 1227" style="margin-right: 5px" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
                </svg>
                <font-awesome-icon v-else :icon="['fab', list.sns_type]" style="margin-right: 5px" />                
                {{ list.list_name }}
              </div>
              <div class="list-detail-num" :class="dark_mode ? 'dark' : ''">
                {{ list.influencer_num }}
              </div>
            </div>
          </div>
          <div v-else-if="list_count == 0" class="list-detail-sidemenu-nolist">リストがありません</div>
        </div>
      </div>
    </div>
    <listExportDialog
      :export_dialog.sync="export_dialog"
      :sns_type="list_detail.sns_type"
      :list_id="list_id"
      :influencer_updating="influencer_update_label === 'updating'"
    />
    <influencerBioSlideSettingModal
      :visible.sync="bio_slide_setting_modal"
      :sns_type="list_detail.sns_type"
      :list_id="list_id"
      :checkList="checkList"
      :checkListDetail="bio_slide_checkListDetail"
      @created="onBioSlideCreated"
    />
    <influencerBioSlideCompleteModal
      :visible.sync="bio_slide_complete_modal"
      :checkListDetail="bio_slide_checkListDetail"
    />
    <listFilter v-if="filter_show" :filter_show="filter_show" @filterClose="filterClose" @filterList="filterList" :filter.sync="filter" :sns_type="list_detail.sns_type" :master="list_detail.master" />
    <createList :create_list.sync="create_list" :type="'change'" :target_list_name="list_detail.list_name" :target_list_id="Number(list_id)" @loadList="loadList" @changeListName="changeListName" />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadListInfluencer = root + "/api/list/load_influencer";
const loadListAPI = root + "/api/list/load_list";
const loadListDetailAPI = root + "/api/list/load_listdetail";
const loadPropertyAPI = root + "/api/note/load_property";
const addInfluencerAPI = root + "/api/list/add_influencer";
const deleteInfluencerAPI = root + "/api/list/delete_influencer";
const addFavoriteAPI = root + "/api/list/add_favorite";
const addStatusAPI = root + "/api/list/add_status";
const listImgUploadAPI = root + "/api/list/img_upload";
const loadMemberAPI = root + "/api/member/load_member";
const changeGenderAPI = root + "/api/admin/change_gender";
const changeBirthdayAPI = root + "/api/admin/change_birthday";
const similarSearchAPI = root + "/api/list/similar_search";
const changeListAPI = root + "/api/list/change_list";
const addMemberAPI = root + "/api/list/add_member";
const deleteMemberFromListAPI = root + "/api/list/delete_member_list";
const changeListViewAPI = root + "/api/list/change_list_view";
const loadTagAPI = root + "/api/list/load_tag";
const addTagAPI = root + "/api/list/add_tag";
const removeTagAPI = root + "/api/list/remove_tag";
const BIO_SLIDE_TRIAL_LIMIT = 5;
const BIO_SLIDE_MONTHLY_LIMIT = 1000;
// リスト詳細ヘッダーの左右エリアはいずれも position:sticky で固定されるため、固定位置と最小間隔を除いた幅で重なりを判定する
// 値は instagram.css の .list-summary(left) / .list-detail-menu-wrap(right) と揃える
const LIST_HEADER_STICKY_LEFT = 290;
const LIST_HEADER_STICKY_RIGHT = 30;
const LIST_HEADER_AREA_GAP = 20;
import memberDropdown from "./list_dropdown_member.vue";
import brandDropdown from "./list_dropdown_brand.vue";
import tagDropdown from "./list_detail_dropdown_tag";
import inboxDetail from "../message/inbox_detail.vue";
import newmessage from "../message/newmessage.vue";
import listFilter from "./filter";
import favorite from "./favorite";
import genderRatio from "./gender_ratio";
import status from "./status";
import comment from "./comment";
import listIn from "./list_in";
import reportIn from "./report_in";
import editInfluencer from "./edit";
import addListButton from "./add_list_button";
import moveListButton from "./move_list_button";
import listExportDialog from "./list_export_dialog";
import influencerBioSlideSettingModal from "./influencer_bio_slide_setting_modal";
import influencerBioSlideCompleteModal from "./influencer_bio_slide_complete_modal";
import listImport from "./list_import";
import createList from "./createList";
import noteInfo from "./list_note_info";
import tableColumn from "../influencer/table_column";
import listDisplayButton from "./list_display_button";
import windowSwitch from "./window_switch";
import snsIconList from "../influencer/sns_icon_list";
import customizeTag from "../influencer/customize_tag";
import stories from "../influencer/stories";
import UserTokenSiteName from "@/components/oem/UserTokenSiteInfo.vue";
import listCommentHeaderGroup from "./list_comment_header_group";
import listCommentCells from "./list_comment_cells";
import listCommentTotalCell from "./list_comment_total_cell";
import listCommentAddDialog from "./list_comment_add_dialog";
import { LIST_COMMENT_MAX_NORMAL_COLUMNS, isDuplicateNormalColumnTitle, LIST_COMMENT_DUPLICATE_TITLE_MESSAGE, LIST_COMMENT_MAX_TITLE_LENGTH } from "@/utils/listCommentConst";

export default {
  name: "listDetail",
  components: {
    memberDropdown,
    brandDropdown,
    tagDropdown,
    inboxDetail,
    newmessage,
    listFilter,
    favorite,
    genderRatio,
    status,
    comment,
    listIn,
    reportIn,
    editInfluencer,
    addListButton,
    moveListButton,
    listExportDialog,
    influencerBioSlideSettingModal,
    influencerBioSlideCompleteModal,
    listImport,
    createList,
    noteInfo,
    tableColumn,
    listDisplayButton,
    windowSwitch,
    snsIconList,
    customizeTag,
    stories,
    UserTokenSiteName,
    listCommentHeaderGroup,
    listCommentCells,
    listCommentTotalCell,
    listCommentAddDialog,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      list_id: 0,
      root: root,
      current_list: "",
      list_status: "",
      list_index: "",
      list_img_url: "",
      list_loading: true,
      influencer_loading: false,
      detail_loading: false,
      list: [],
      tag_list: [],
      active_list_count: "",
      list_detail: [],
      list_data: [],
      list_count: -1,
      count: 0,
      next_cursor: [],
      img_change: false,
      img_error: false,
      file: "",
      fileList: [],
      filter_show: false,
      filter: [],
      filtered: false,
      filtered_total: [],
      filtered_select_all: null,
      result_count: -1,
      account_name: "",
      category: "",
      sort_key: "followers_count",
      sort_order: "desc",
      sort_keyword: "",
      search_keyword: "",
      infiniteId: +new Date(),
      checkList: [],
      checkListDetail: [],
      checkAll_val: false,
      checkAll_dropdown: false,
      checkedCount: 0,
      client_id: 1,
      client_name: "reech",
      noinfluencer: false,
      notfound: false,
      drawer: false,
      search_dropdown: "",
      search_dropdown_regexp: "",
      search_dropdown_add: "",
      search_dropdown_add_regexp: "",
      max_width: "100%",
      data_table_width: "",
      account_name_width: "",
      requestId: +new Date(),
      requestDetailId: +new Date() + 10000,
      requestListId: +new Date() + 100000,
      height_sample: 0,
      nolist: false,
      all_member: {
        person_id: "all",
      },
      all_client: {
        target_client_id: "all",
      },
      list_search_word: "",
      member: [],
      client: [],
      message_drawer: false,
      dm_ig_id: "",
      newmessage_drawer: false,
      html: "",
      add_influencer_modal: false,
      similar_loading: false,
      favorite_mouseover: "",
      edit_drawer: false,
      properties: [],
      property_loading: true,
      export_dialog: false,
      bio_slide_setting_modal: false,
      bio_slide_complete_modal: false,
      bio_slide_checkListDetail: [],
      age_check: false,
      create_list: false,
      mounted: false,
      influencer_update_label: null,
      influencer_update_count: 0,
      influencer_updating_list: [],
      influencer_updating_id_map: {},
      influencer_update_was_updating: false,
      influencer_update_notified: false,
      _influencerUpdatePollTimer: null,
      current_page: 1,
      limit: 20,
      sns_list: [
        { value: "all", name: "全てのSNS" },
        { value: "instagram", name: "Instagram" },
        { value: "youtube", name: "YouTube" },
        { value: "tiktok", name: "TikTok" },
        { value: "twitter", name: "X" },
        { value: "master", name: "マスター" },
      ],
      person_title: "",
      specialty_categories_genres: "",
      post_format: "",
      darkLogo: "",
      logo: "",
      logoText: "",
      isOem: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
      has_recent_post_1month: false,
      comment_columns: [],
      comment_add_dialog: false,
      comment_title_dialog: false,
      comment_title_edit_column: null,
      comment_title_edit_value: "",
      header_area_stacked: false,
    };
  },
  computed: {
    dark_mode() {
      return this.$store.state.dark_mode;
    },
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    sessionid() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.sessionid;
      } else {
        return null;
      }
    },
    openMenu() {
      return this.$store.state.openMenu;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    printmode() {
      return false;
      // if (this.admin_mode) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    window_switch() {
      return this.$store.state.window_switch;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    item() {
      return this.$store.state.list_item;
    },
    list_sns_type() {
      return this.$store.state.list_sns_type;
    },
    list_sns_name() {
      var name = "";
      for (let i = 0; i < this.sns_list.length; i++) {
        if (this.list_sns_type === this.sns_list[i].value) name = this.sns_list[i].name;
      }
      return name;
    },
    list_view_style() {
      return this.$store.state.list_view_style;
    },
    member_select() {
      return this.$store.state.member_select;
    },
    client_select() {
      return this.$store.state.client_select;
    },
    item_info() {
      var info = {
        item: this.item,
        sort_key: this.sort_key,
        sort_order: this.sort_order,
      };
      return info;
    },
    normalCommentColumnCount() {
      return this.comment_columns.filter((col) => col.column_type === "normal").length;
    },
    canAddCommentColumn() {
      return this.normalCommentColumnCount < LIST_COMMENT_MAX_NORMAL_COLUMNS;
    },
    check_list_status() {
      if (this.list.influencer) {
        var checkCount = 0;
        if (this.list_detail.sns_type == "instagram") var id_type = "ig_id";
        if (this.list_detail.sns_type == "youtube") id_type = "channel_id";
        if (this.list_detail.sns_type == "tiktok") id_type = "tt_id";
        if (this.list_detail.sns_type == "twitter") id_type = "tw_id";
        for (let i = 0; i < this.list.influencer.length; i++) {
          for (let ii = 0; ii < this.checkList.length; ii++) {
            if (this.list.influencer[i][id_type] == this.checkList[ii]) checkCount += 1;
          }
        }
        if (checkCount == this.list.influencer.length) {
          return "all";
        } else if (checkCount > 0) {
          return "some";
        } else {
          return "none";
        }
      } else {
        return "none";
      }
    },
    is_send_bulk_message() {
      if (!this.connect_ig_account_limit_num > 0) return { 'status': false, 'message': '', 'statusInbox': false }
      if (this.ig_info == '') return { 'status': false, 'message': 'Instagramアカウントが未連携です', 'statusInbox': false }
      if (this.checkList.length > 150) return { 'status': false, 'message': 'メッセージは150名以上には一斉送信できません', 'statusInbox': true }
      return { 'status': true, 'message': '', 'statusInbox': true }
    },
    create_influencer_list_limit_num() {
      return this.$store.state.service_plan.create_influencer_list_limit_num;
    },
    export_influencer_list_enabled() {
      return this.$store.state.service_plan.export_influencer_list_enabled ? true : false;
    },
    connect_ig_account_limit_num() {
      return this.$store.state.service_plan.connect_ig_account_limit_num;
    },
    view_influencer_list_enabled() {
      return this.$store.state.service_plan.view_influencer_list_enabled ? true : false;
    },
    bio_slide_member_slide_export_count() {
      const memberInfo = this.$store.state.member_info;
      if (!memberInfo || Array.isArray(memberInfo)) return 0;
      return memberInfo.intro_slide_export_count ?? 0;
    },
    bio_slide_client_slide_export_count() {
      return this.$store.state.intro_slide_export_client_count ?? 0;
    },
    bio_slide_max_influencers() {
      return this.activate === 11 ? 10 : 100;
    },
    is_influencer_bio_slide() {
      if (this.checkList.length === 0) {
        return { status: false, message: "" };
      }
      if (!this.view_influencer_list_enabled) {
        return { status: false, message: "現在、ご利用できません" };
      }
      if( this.activate === 11){
        if( this.bio_slide_member_slide_export_count >= BIO_SLIDE_TRIAL_LIMIT){
          return { status: false, message: "現在、ご利用できません" };
        }
      }else{
        if( this.bio_slide_client_slide_export_count >= BIO_SLIDE_MONTHLY_LIMIT){
          return { status: false, message: "現在、ご利用できません" };
        }
      }
      if (this.checkList.length > this.bio_slide_max_influencers) {
        return {
          status: false,
          message: `選択できるインフルエンサーは、最大${this.bio_slide_max_influencers}人です`,
        };
      }
      return { status: true, message: "" };
    },
  },
  created() {
    // ResizeObserverのインスタンスはリアクティブにする必要がないためdataには持たせない
    this.headerAreaObserver = null;
  },
  mounted() {
    window.addEventListener("resize", this.calcWidth);
    this.observeHeaderAreaSize();
    this.loadQuery();
    this.loadListDetail();
    this.loadList(true);
    this.loadProperty();
    this.loadMember();
    this.loadTag();
    this.openSideMenu();
    this.startInfluencerUpdatePolling();
    this.bindInfluencerUpdateVisibilityListener();
    this.mounted = true;
  },
  methods: {
    /**
     * リスト詳細向けのインフルエンサー更新ステータス監視を開始する。
     * 負荷軽減のため常時短間隔ポーリングはせず、
     * 画面表示時チェック + 更新中のみ長間隔ポーリングとする。
     */
    startInfluencerUpdatePolling() {
      this.stopInfluencerUpdateInterval();
      this.influencer_update_label = null;
      this.influencer_update_count = 0;
      this.influencer_updating_list = [];
      this.influencer_updating_id_map = {};
      this.influencer_update_was_updating = false;
      this.influencer_update_notified = false;
      this.pollInfluencerUpdateStatus();
    },
    /**
     * タブ復帰時にステータスを再取得する listener を登録する
     */
    bindInfluencerUpdateVisibilityListener() {
      this.unbindInfluencerUpdateVisibilityListener();
      this._onInfluencerUpdateVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          this.pollInfluencerUpdateStatus();
        }
      };
      document.addEventListener("visibilitychange", this._onInfluencerUpdateVisibilityChange);
    },
    /**
     * visibilitychange listener を解除する
     */
    unbindInfluencerUpdateVisibilityListener() {
      if (this._onInfluencerUpdateVisibilityChange) {
        document.removeEventListener("visibilitychange", this._onInfluencerUpdateVisibilityChange);
        this._onInfluencerUpdateVisibilityChange = null;
      }
    },
    /**
     * 更新中のみ長間隔ポーリングを開始する（完了検知用）
     */
    startInfluencerUpdateInterval() {
      if (this._influencerUpdatePollTimer) {
        return;
      }
      // 更新中のみ 30 秒間隔で確認する（常時短間隔ポーリングはしない）
      this._influencerUpdatePollTimer = setInterval(() => {
        this.pollInfluencerUpdateStatus();
      }, 30000);
    },
    /**
     * 更新中ポーリングを停止する
     */
    stopInfluencerUpdateInterval() {
      if (this._influencerUpdatePollTimer) {
        clearInterval(this._influencerUpdatePollTimer);
        this._influencerUpdatePollTimer = null;
      }
    },
    /**
     * 更新ステータス監視を停止する
     */
    stopInfluencerUpdatePolling() {
      this.stopInfluencerUpdateInterval();
      this.unbindInfluencerUpdateVisibilityListener();
    },
    /**
     * 更新中ステータスを取得し、必要ならトースト通知する
     * （右上は「更新中」のみ表示。完了ラベルは出さない）
     */
    pollInfluencerUpdateStatus() {
      if (!this.token || !this.list_id) {
        return;
      }
      this.$store
        .dispatch("pollInfluencerUpdateStatus", { listId: this.list_id })
        .then((result) => {
          const updating = !!(result && result.updating);
          const notifications = (result && result.notifications) || [];
          const updatingInfluencers = (result && result.updating_influencers) || [];
          this.influencer_update_count = Number((result && result.updating_count) || 0);
          this.influencer_updating_list = updatingInfluencers;
          const idMap = {};
          updatingInfluencers.forEach((item) => {
            if (item && item.id !== undefined && item.id !== null) {
              idMap[String(item.id)] = true;
            }
          });
          this.influencer_updating_id_map = idMap;

          if (updating) {
            this.influencer_update_label = "updating";
            this.influencer_update_was_updating = true;
            this.influencer_update_notified = false;
            this.startInfluencerUpdateInterval();
            return;
          }

          // 更新中でなければポーリング停止し、右上ステータスも消す
          this.stopInfluencerUpdateInterval();
          this.influencer_update_label = null;

          const justCompleted = this.influencer_update_was_updating;
          const hasUnread = notifications.length > 0;
          this.influencer_update_was_updating = false;

          // 完了通知があるときだけトースト（失敗時は更新中維持・通知なし / 削除時はトースト不要）
          if (!this.influencer_update_notified && hasUnread) {
            this.loadListDetail();
            this.loadQuery();
            this.showInfluencerUpdateCompletedMessage(notifications);
            this.influencer_update_notified = true;
            return this.$store.dispatch("ackInfluencerUpdateNotifications", {
              listId: this.list_id,
            });
          }

          // 削除などで更新中が消えた場合はフラグだけ戻す
          if (justCompleted) {
            this.influencer_update_notified = false;
          }
        })
        .catch(() => {});
    },
    /**
     * リスト追加・削除直後に更新中ステータスを即時再取得する
     * （キックはレスポンス前後でキャッシュが立つ想定だが、念のため短い再試行も行う）
     */
    refreshInfluencerUpdateStatus() {
      this.pollInfluencerUpdateStatus();
      // 追加直後にキャッシュ反映がわずかに遅れるケース向け
      setTimeout(() => {
        this.pollInfluencerUpdateStatus();
      }, 1500);
    },
    /**
     * 指定アカウントが更新中かどうか
     * @param {string|number} id
     * @returns {boolean}
     */
    isInfluencerUpdating(id) {
      if (id === undefined || id === null || id === "") {
        return false;
      }
      return !!this.influencer_updating_id_map[String(id)];
    },
    /**
     * 更新完了トーストを表示する
     * @param {Array} notifications
     */
    showInfluencerUpdateCompletedMessage(notifications) {
      const successItems = (notifications || []).filter((n) => n.success !== false);
      const failedItems = (notifications || []).filter((n) => n.success === false);
      let message = "インフルエンサー情報の更新が完了しました";

      if (successItems.length === 1) {
        const name = successItems[0].account_name || successItems[0].id || "";
        message = name
          ? `「${name}」のインフルエンサー情報の更新が完了しました`
          : message;
      } else if (successItems.length > 1) {
        message = `${successItems.length}名のインフルエンサー情報の更新が完了しました`;
      } else if (failedItems.length > 0) {
        message = "インフルエンサー情報の更新に失敗しました";
      }

      this.$message({
        type: failedItems.length > 0 && successItems.length === 0 ? "warning" : "success",
        offset: 7,
        showClose: true,
        message,
      });
    },
    toggleRecentPost1Month() {
      this.list = [];
      this.count = 0;
      this.current_page = 1;
      this.infiniteId += 1;
    },
    loadQuery() {
      this.influencer_loading = true;
      this.scrollTop();
      this.list_id = Number(this.$route.params.list_id);
      this.noinfluencer = false;
      this.notfound = false;
      this.checkList = [];
      this.checkAll_val = false;
      this.filter_show = false;
      this.filtered = false;
      this.filter = [];
      this.list = [];
      this.count = 0;
      this.result_count = 1;
      this.comment_columns = [];
      this.comment_add_dialog = false;
      this.infiniteId += 1;
    },
    infiniteHandler($state) {
      // this.influencer_loading = true;
      this.nolist = false;
      this.notfound = false;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("sort_keyword", this.sort_keyword);
      params.append("search_keyword", this.search_keyword);
      params.append("filter", JSON.stringify(this.filter));
      params.append("has_recent_post_1month", this.has_recent_post_1month ? 1 : 0);
      params.append("count", this.count);
      params.append("next_cursor", this.count > 0 ? JSON.stringify(this.next_cursor) : "");
      this.axios.post(loadListInfluencer, params, { requestId: this.requestId }).then((response) => {
        var data = response.data || {};
        if (data.status != "OK") {
          this.loadInfluencerFailed(data, $state, this.count == 0);
          return;
        }
        this.result_count = response.data.result_count;
        if (this.result_count > this.count) {
          this.filtered_total = response.data.filtered_total || [];
          this.filtered_select_all = response.data.filtered_select_all;
          if (this.count == 0) {
            this.list = response.data;
            this.comment_columns = response.data.comment_columns || [];
            this.next_cursor = response.data.next_cursor;
            this.count += 20;
            this.influencer_loading = false;
            $state.loaded();
            this.$nextTick(() => {
              this.calcWidth(); //テーブルの横サイズを取得
            });
          } else {
            var newinfluencer = this.list.influencer.concat(response.data.influencer);
            this.list.influencer = newinfluencer;
            this.count += 20;
            $state.loaded();
            this.influencer_loading = false;
          }
          if (this.result_count <= this.count) {
            $state.complete();
          }
        } else {
          if (this.result_count == 0) {
            if (response.data.sort_mode == true) {
              this.notfound = true;
            } else {
              this.noinfluencer = true;
            }
          } else {
            this.noinfluencer = false;
          }
          $state.complete();
          this.influencer_loading = false;
        }
        this.$nextTick(() => {
          this.sidemenuScroll();
        });
      });
    },
    loadInfluencer($state) {
      this.list = [];
      this.nolist = false;
      this.notfound = false;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      var params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("sort_keyword", this.sort_keyword);
      params.append("search_keyword", this.search_keyword);
      params.append("filter", JSON.stringify(this.filter));
      params.append("has_recent_post_1month", this.has_recent_post_1month ? 1 : 0);
      params.append("count", (this.current_page - 1) * this.limit);
      params.append("limit", this.limit);
      params.append("next_cursor", this.count > 0 ? JSON.stringify(this.next_cursor) : "");
      this.axios.post(loadListInfluencer, params, { requestId: this.requestId }).then((response) => {
        var data = response.data || {};
        if (data.status != "OK") {
          this.loadInfluencerFailed(data, $state, true);
          return;
        }
        this.result_count = response.data.result_count;
        this.filtered_total = response.data.filtered_total || [];
        this.filtered_select_all = response.data.filtered_select_all;
        this.list = response.data;
        this.comment_columns = response.data.comment_columns || [];
        this.next_cursor = response.data.next_cursor;
        this.count += 20;
        this.influencer_loading = false;
        this.$nextTick(() => {
          this.calcWidth(); //テーブルの横サイズを取得
        });
        if (this.result_count == 0) {
          if (response.data.sort_mode == true) {
            this.notfound = true;
          } else {
            this.noinfluencer = true;
          }
        } else {
          this.noinfluencer = false;
        }
        this.influencer_loading = false;
        $state.complete();
        this.$nextTick(() => {
          this.sidemenuScroll();
        });
      });
    },
    /**
     * インフルエンサー取得APIがOK以外を返した場合の後処理
     * NGレスポンスには result_count / filtered_total が含まれないため、合計行を描画させないよう初期化する
     * @param {Object} data レスポンスボディ
     * @param {Object} $state vue-infinite-loading の state
     * @param {Boolean} reset 表示中の一覧を初期化するか（追加読み込み時は維持する）
     */
    loadInfluencerFailed(data, $state, reset) {
      this.influencer_loading = false;
      if (reset) {
        this.result_count = 0;
        this.filtered_total = [];
        this.filtered_select_all = null;
        this.list = [];
        if (data.sort_mode == true || this.filtered || this.sort_keyword) {
          this.notfound = true;
        } else {
          this.noinfluencer = true;
        }
      }
      $state.complete();
      this.$nextTick(() => {
        this.sidemenuScroll();
      });
    },
    pageChange() {
      this.list = [];
      this.infiniteId += 1;
    },
    limitChange() {
      this.list = [];
      this.current_page = 1;
      this.infiniteId += 1;
    },
    changeListView(list_view_style) {
      this.$store.dispatch("changeListView", list_view_style);
      var params = new URLSearchParams();
      params.append("user_token", this.user_token);
      params.append("list_view_style", list_view_style);
      this.axios
        .post(changeListViewAPI, params)
        .then(() => {})
        .catch(() => {});
      this.list = [];
      this.count = 0;
      this.current_page = 1;
      this.$nextTick(() => {
        this.infiniteId += 1;
      });
    },
    loadListDetail() {
      this.detail_loading = true;
      this.axios.cancel(this.requestDetailId);
      this.requestDetailId += 1;
      this.axios
        .get(loadListDetailAPI, {
          requestId: this.requestDetailId,
          params: {
            list_id: this.list_id,
            token: this.token,
          },
        })
        .then((response) => {
          if (response.data.status == "OK") {
            this.list_detail = response.data.mylist;
            this.detail_loading = false;
          } else {
            this.$router.push("/404");
          }
        });
    },
    loadProperty() {
      this.property_loading = true;
      this.axios
        .get(loadPropertyAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.properties = response.data.properties;
          this.property_loading = false;
        });
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.sort_key = value;
      this.list = [];
      this.count = 0;
      this.current_page = 1;
      this.infiniteId += 1;
    },
    sortKeyword() {
      this.list = [];
      this.count = 0;
      this.infiniteId += 1;
    },
    searchMedia() {
      this.list = [];
      this.count = 0;
      this.infiniteId += 1;
      this.item.recent_post = true;
    },
    loadList(loading) {
      if (loading) this.list_loading = true;
      this.axios.cancel(this.requestListId);
      this.requestListId += 1;
      this.axios
        .get(loadListAPI, {
          requestId: this.requestListId,
          params: {
            token: this.token,
            search_word: this.list_search_word,
            sort_key: this.list_sort_key,
            sort_order: this.list_sort_order,
            person_id: this.member_select.person_id,
            target_client_id: this.client_select.target_client_id,
            sns_type: this.list_sns_type,
            type: "side",
            list_index: this.list_index,
          },
        })
        .then((response) => {
          this.list_data = response.data.mylist;
          this.list_count = response.data.result_count;
          this.active_list_count = response.data.active_list_count;
          const list_data = this.list_data;
          for (let index = 0; index < list_data.length; index++) {
            if (list_data[index].list_id == this.list_id) {
              this.list_index = index;
            }
          }
          this.list_loading = false;
          this.checkAll_val = false;
        });
    },
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.member = response.data.member;
          this.client = response.data.target_client;
        });
    },
    loadTag() {
      this.axios
        .get(loadTagAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
        })
        .catch(() => {});
    },
    selectMember(member) {
      this.$store.dispatch("selectMember", member);
      this.loadList(true);
    },
    selectClient(client) {
      this.$store.dispatch("selectClient", client);
      this.loadList(true);
    },
    selectSNS(sns) {
      this.$store.dispatch("changeListSnsType", sns.value);
      if (sns.value == "master") {
        this.$store.dispatch("selectMember", this.all_member);
        this.$store.dispatch("selectClient", this.all_client);
      }
      this.loadList(true);
    },
    searchList() {
      // if (value=='') {
      //   var boolean = false
      // } else {
      //   boolean = true
      // }
      // this.$store.dispatch("searchList", {list_search_word:value, list_search: boolean});
      this.loadList(true);
    },
    listOpen(id) {
      this.sort_order = "desc";
      this.sort_key = "followers_count";
      (this.sort_keyword = ""),
        this.$router.push({
          name: "listDetail",
          params: {
            list_id: id,
            member_select: this.member_select,
          },
        });
    },
    loadFromDetail(list_id) {
      this.loadList();
      if (this.list_id == list_id) {
        this.list = [];
        this.count = 0;
        this.result_count = 1;
        this.noinfluencer = false;
        this.infiniteId += 1;
      }
    },
    clearList() {
      this.checkAll_val = false;
      this.checkList = [];
    },
    addInfluencer(id, name, num) {
      this.$confirm(num + "名のインフルエンサーを「" + name + "」に追加しますか？", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        type: "info",
      }).then(() => {
        this.$message({
          type: "info",
          duration: 0,
          offset: 7,
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: 'リストにインフルエンサーを追加中です<div class="loader--mini"></div>',
        });
        var params = new URLSearchParams();
        params.append("list_id", id);
        params.append("influencer", JSON.stringify(this.checkList));
        params.append("sns_type", this.list_detail.sns_type);
        params.append("token", this.token);
        this.axios.post(addInfluencerAPI, params).then((response) => {
          if (response.data.status == "block") {
            this.$message.closeAll();
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "PR依頼中のリストは内容を変更できません",
            });
          } else {
            // this.loadQuery();
            // this.loadList();
            // this.loadListDetail();
            this.checkList = [];
            this.checkAll_val = false;
            this.$message.closeAll();
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: num + "名のインフルエンサーを" + name + "に追加しました",
            });
            this.$store.dispatch("loadSidemenuOption", this.token);
          }
        });
      });
    },
    deleteInfluencer() {
      if (this.permission.list.edit) {
        const num = this.checkList.length;
        this.$confirm(num + "名のインフルエンサーを「" + this.list_detail.list_name + "」から削除しますか？", "インフルエンサーの削除", {
          confirmButtonText: "削除",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
          type: "warning",
        }).then(() => {
          this.$message({
            type: "info",
            duration: 0,
            offset: 7,
            dangerouslyUseHTMLString: true,
            message: 'リストからインフルエンサーを削除中です<div class="loader--mini"></div>',
          });
          var params = new URLSearchParams();
          params.append("list_id", this.list_id);
          params.append("sns_type", this.list_detail.sns_type);
          params.append("influencer", JSON.stringify(this.checkList));
          params.append("token", this.token);
          this.axios.post(deleteInfluencerAPI, params).then((response) => {
            if (response.data.status == "block") {
              this.$message.closeAll();
              this.$message({
                type: "error",
                message: "PR依頼中のリストは内容を変更できません",
              });
            } else {
              this.loadQuery();
              this.loadList();
              this.loadListDetail();
              this.refreshInfluencerUpdateStatus();
              this.$message.closeAll();
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: num + "名のインフルエンサーを" + this.list_detail.list_name + "から削除しました",
              });
            }
          });
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    sortCommentColumn(sortKey) {
      if (this.sort_key != sortKey) {
        this.sort_order = "desc";
      } else {
        this.sort_order = this.sort_order == "asc" ? "desc" : "asc";
      }
      this.sort_key = sortKey;
      this.list = [];
      this.count = 0;
      this.current_page = 1;
      this.infiniteId += 1;
    },
    onCommentColumnAdded(column) {
      this.comment_columns.push(column);
      this.comment_columns.sort((a, b) => {
        if (a.column_type === "post_url") return 1;
        if (b.column_type === "post_url") return -1;
        return Number(a.sort_order) - Number(b.sort_order);
      });
      this.$nextTick(() => {
        this.calcWidth();
      });
      this.reloadInfluencerList();
    },
    openCommentTitleEdit(column) {
      this.comment_title_edit_column = column;
      this.comment_title_edit_value = column.title || "";
      this.$prompt("コメントタイトルを入力", "タイトル編集", {
        confirmButtonText: "保存",
        cancelButtonText: "キャンセル",
        inputValue: column.title || "",
        inputValidator: (val) => {
          if (val !== null && val.length > LIST_COMMENT_MAX_TITLE_LENGTH) {
            return "30文字以内で入力してください";
          }
          if (isDuplicateNormalColumnTitle(val, this.comment_columns, column.column_id)) {
            return LIST_COMMENT_DUPLICATE_TITLE_MESSAGE;
          }
          return true;
        },
      }).then(({ value }) => {
        this.updateCommentColumnTitle(column, value);
      });
    },
    updateCommentColumnTitle(column, title) {
      const root = process.env.VUE_APP_API;
      const params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("column_id", column.column_id);
      params.append("token", this.token);
      params.append("title", title || "");
      this.axios.post(root + "/api/list/update_comment_column_title", params).then((response) => {
        if (response.data.status === "OK") {
          const idx = this.comment_columns.findIndex((c) => c.column_id === column.column_id);
          if (idx >= 0) {
            this.$set(this.comment_columns, idx, response.data.comment_column);
          }
        } else {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: response.data.message || "タイトルを更新できませんでした",
          });
        }
      });
    },
    deleteCommentColumn(column) {
      if (this.normalCommentColumnCount <= 1) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "コメント列は最低1列必要です",
        });
        return;
      }
      this.$confirm("このコメント列を削除しますか？削除後は復元できません。", "コメント列の削除", {
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
        type: "warning",
      }).then(() => {
        const root = process.env.VUE_APP_API;
        const params = new URLSearchParams();
        params.append("list_id", this.list_id);
        params.append("column_id", column.column_id);
        params.append("token", this.token);
        this.axios.post(root + "/api/list/delete_comment_column", params).then((response) => {
          if (response.data.status === "OK") {
            this.comment_columns = this.comment_columns.filter((c) => c.column_id !== column.column_id);
            if (this.sort_key === "comment_column_" + column.column_id) {
              this.sort_key = this.list_detail.sns_type === "youtube" ? "subscriberCount" : "followers_count";
              this.sort_order = "desc";
            }
            this.reloadInfluencerList();
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "コメント列を削除できませんでした",
            });
          }
        });
      });
    },
    reloadInfluencerList() {
      this.list = [];
      this.count = 0;
      this.current_page = 1;
      this.infiniteId += 1;
    },
    syncComment(index, value, type, columnId) {
      if (type == "comment" || type == "comment_column") {
        if (columnId) {
          if (!this.list.influencer[index].comment_values) {
            this.$set(this.list.influencer[index], "comment_values", {});
          }
          this.$set(this.list.influencer[index].comment_values, String(columnId), value);
        }
        this.list.influencer[index].client_comment = value;
      } else if (type == "num") {
        this.list.influencer[index].num = value;
      } else if (type == "personalized_name") {
        this.list.influencer[index].personalized_name = value;
        var ig_id = this.list.influencer[index].ig_id;
        this.list_detail.for_dm[ig_id].personalized_name = value;
        if (this.checkList.length > 0) this.syncNewmessageCheckList(); //チェック済みの場合、DMプレビュー用の宛名などを同期させるためにsyncNewmessageCheckListを再実行
      } else if (type == "personalized_price") {
        ig_id = this.list.influencer[index].ig_id;
        this.list.influencer[index].personalized_price = value;
        this.list_detail.for_dm[ig_id].personalized_price = value;
        if (this.checkList.length > 0) this.syncNewmessageCheckList();
      }
    },
    syncStatus(index, value) {
      this.list.influencer[index].status = value;
    },
    changeFavorite(index) {
      if (this.list.influencer[index].favorite == 0) {
        this.list.influencer[index].favorite = 1;
      } else {
        this.list.influencer[index].favorite = 0;
      }
      var params = new URLSearchParams();
      params.append("influencer", this.list_detail.sns_type == "instagram" ? this.list.influencer[index].ig_id : this.list.influencer[index].channel_id);
      params.append("sns_type", this.list_detail.sns_type);
      params.append("favorite", this.list.influencer[index].favorite);
      params.append("token", this.token);
      this.axios.post(addFavoriteAPI, params);
    },
    favoriteReactive(index, favorite) {
      this.list.influencer[index].favorite = favorite;
    },
    addInfluencerReactive(index, list_name, list_id) {
      if (!this.list.influencer[index].list_in) {
        this.list.influencer[index].list_in = [];
      }
      this.list.influencer[index].list_count += 1;
      this.list.influencer[index].list_in.push({
        list_name: list_name,
        list_id: list_id,
      });
      if (String(list_id) === String(this.list_id)) {
        this.refreshInfluencerUpdateStatus();
      }
    },
    deleteInfluencerReactive(index, list_id) {
      var list_in = this.list.influencer[index].list_in;
      for (let i = 0; i < list_in.length; i++) {
        if (this.list.influencer[index].list_in[i].list_id == list_id) {
          this.list.influencer[index].list_in.splice(i, 1);
        }
      }
      this.list.influencer[index].list_count -= 1;
      if (String(list_id) === String(this.list_id)) {
        this.refreshInfluencerUpdateStatus();
      }
    },
    addStatus(id, value, index) {
      var params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("influencer", id);
      params.append("sns_type", this.list_detail.sns_type);
      params.append("status", value);
      params.append("token", this.token);
      this.axios.post(addStatusAPI, params).then(() => {
        this.list.influencer[index].status = value;
        this.active_comment = "";
        this.loadList();
      });
    },
    exportListDetail() {
      if (this.$store.state.permission.export.access) {
        this.export_dialog = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    similarSearch() {
      this.similar_loading = true;
      var params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("token", this.token);
      this.axios
        .post(similarSearchAPI, params)
        .then((response) => {
          if (response.data.noexist_count > 0) {
            this.$confirm(
              "<div>下記の" + response.data.noexist.length + '名の未登録インフルエンサーが見つかりました。<div class="import-influencer-noexist"><div>' + response.data.noexist_str + "</div>",
              "未登録インフルエンサー",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "上記インフルエンサーの新規登録をリクエスト",
                cancelButtonText: "閉じる",
                showCancelButton: true,
                type: "warning",
                customClass: "import-influencer",
              }
            ).then(() => {
              this.$router.push({
                name: "request",
                params: {
                  influencer_bulk: response.data.noexist_str_for_request,
                  request_drawer: true,
                  sns_type: this.list_detail.sns_type,
                },
              });
            });
          } else {
            // noexist_count が 0 の場合の処理
            this.$alert(
                "未登録のインフルエンサーは見つかりませんでした。",
                "未登録インフルエンサー",
                {
                  confirmButtonText: "OK",
                  type: "info",
                }
            );
          }
          this.similar_loading = false;
        })
        .catch(() => {
          this.similar_loading = false;
        });
    },
    toSearchPage() {
      this.$emit("sidemenuScroll", this.list_detail.sns_type);
      // if (this.openMenu !== [2]) {
        this.$store.dispatch("snsType", this.list_detail.sns_type);
        this.$store.dispatch("changeOpeneds", ["2"]);
      // }
      this.$router.push("/" + this.list_detail.sns_type);
    },
    openChangeListName() {
      if (this.permission.list.edit) {
        this.create_list = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeListName(list_name) {
      this.list_detail.list_name = list_name;
      this.loadList();
    },
    openImgDrawer() {
      if (this.permission.list.edit) {
        this.img_change = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    imgAdd(file, fileList) {
      this.file = file;
      this.fileList = fileList;
    },
    imgUpload() {
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "list");
      formData.append("list_id", this.list_id);
      formData.append("token", this.token);
      this.axios.post(listImgUploadAPI, formData, config).then((response) => {
        this.list_detail.img_url = response.data[0].img_url;
        this.file = "";
        this.fileList = [];
        this.img_change = false;
        this.$message({
          type: "success",
          offset: 7,
          message: "リストイメージ画像を変更しました",
        });
      });
    },
    checkAll() {
      const allInfluencer = [];
      for (let i = 0; i < this.list.influencer.length; i++) {
        if (this.list_detail.sns_type == "instagram") {
          allInfluencer[i] = this.list.influencer[i].ig_id;
        } else if (this.list_detail.sns_type == "youtube") {
          allInfluencer[i] = this.list.influencer[i].channel_id;
        } else if (this.list_detail.sns_type == "tiktok") {
          allInfluencer[i] = this.list.influencer[i].tt_id;
        } else if (this.list_detail.sns_type == "twitter") {
          allInfluencer[i] = this.list.influencer[i].tw_id;
        }
      }
      if (this.checkAll_val) {
        this.checkList = allInfluencer;
      } else {
        this.checkList = [];
      }
    },
    checkAll_pagination(type) {
      if (this.list_detail.sns_type == "instagram") var id_type = "ig_id";
      if (this.list_detail.sns_type == "youtube") id_type = "channel_id";
      if (this.list_detail.sns_type == "tiktok") id_type = "tt_id";
      if (this.list_detail.sns_type == "twitter") id_type = "tw_id";
      if (type == "auto") {
        if (this.check_list_status == "all") type = "unselect";
        if (this.check_list_status == "some") type = "unselect";
        if (this.check_list_status == "none") type = "select";
      }
      if (type == "select") {
        for (let i = 0; i < this.list.influencer.length; i++) {
          if (!this.checkList.includes(this.list.influencer[i][id_type])) this.checkList.push(this.list.influencer[i][id_type]);
        }
      } else if (type == "unselect") {
        for (let i = 0; i < this.list.influencer.length; i++) {
          if (this.checkList.includes(this.list.influencer[i][id_type])) {
            var index = this.checkList.indexOf(this.list.influencer[i][id_type]);
            this.checkList.splice(index, 1);
          }
        }
      } else if (type == "selectAll") {
        this.checkList = [];
        this.checkList = this.checkList.concat(this.filtered ? this.filtered_select_all : this.list_detail.select_all);
      } else if (type == "unselectAll") {
        this.checkList = [];
      }
    },
    activeComment(value, comment) {
      this.comment_before = comment;
      this.active_comment = value;
      setTimeout(() => {
        document.getElementById(value).focus();
      }, 200);
    },
    inactiveComment() {
      this.active_comment = "";
    },
    updateTag(type, tag_index, new_tag, influencer_index) {
      if (type == "add") {
        this.list.influencer[influencer_index].tags.push(new_tag);
      } else if (type == "delete") {
        this.list.influencer[influencer_index].tags.splice(tag_index, 1);
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    openDrawer(value, index, default_search) {
      if (this.filter.post_keyword) {
        var search_keyword = this.filter.post_keyword;
      } else if (this.age_check && this.admin_mode) {
        search_keyword = "歳を迎えました|歳になりました|才になりました|歳も頑張ります|歳もがんばります|歳の誕生日";
      }
      this.drawer = true;
      document.documentElement.style.overflow = "hidden";
      if (this.list_detail.sns_type == "instagram") var toName = "list_influencerDetailDrawer";
      if (this.list_detail.sns_type == "youtube") toName = "list_youtuberDetailDrawer";
      if (this.list_detail.sns_type == "tiktok") toName = "list_tiktokerDetailDrawer";
      if (this.list_detail.sns_type == "twitter") toName = "list_twittererDetailDrawer";
      this.$router.push({
        name: toName,
        params: {
          channel_id: value,
          account_name: value,
          influencer_index: index,
          default_search: default_search,
          child: true,
          parent_component: "list",
          search_keyword: search_keyword,
          search_type: default_search ? "keyword" : "all",
        },
      });
    },
    openNewWindow(value) {
      if (this.list_detail.sns_type == "instagram") var toName = "influencerDetail";
      if (this.list_detail.sns_type == "youtube") toName = "youtuberDetail";
      if (this.list_detail.sns_type == "tiktok") toName = "tiktokerDetail";
      if (this.list_detail.sns_type == "twitter") toName = "twittererDetail";
      let routeData = this.$router.resolve({
        name: toName,
        params: {
          account_name: value,
          channel_id: value,
          child: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeDrawer() {
      this.drawer = false;
      this.age_check = false;
      document.documentElement.style.overflow = "auto";
      this.$refs.iDetail.closeParentDrawer();
      this.$router.push({
        name: "listDetail",
        params: {
          list_id: this.list_id,
          backpage: true,
        },
      });
    },
    calcWidth() {
      var sum = 0;
      for (let key of Object.keys(this.item)) {
        const width = document.getElementById("item_" + key) ? document.getElementById("item_" + key).getBoundingClientRect().width : 0;
        sum += width;
      }
      var personal_width = 0;
      for (let i = 0; i < this.properties.length; i++) {
        personal_width += document.getElementById("item_personal_" + this.properties[i].property_name)
          ? document.getElementById("item_personal_" + this.properties[i].property_name).getBoundingClientRect().width
          : 0;
      }
      const dm_width = document.getElementById("item_dm") ? document.getElementById("item_dm").getBoundingClientRect().width : 0;
      // 関連カテゴリ幅
      const tr_category = document.getElementById("item_category") ? document.getElementById("item_category").getBoundingClientRect().width : 0;
      // マッピング表示幅
      const tr_person_title_width = document.getElementById("item_attribute_person_title") ? document.getElementById("item_attribute_person_title").getBoundingClientRect().width : 0;
      const tr_specialty_categories_genres = document.getElementById("item_attribute_specialty_categories_genres") ? document.getElementById("item_attribute_specialty_categories_genres").getBoundingClientRect().width : 0;
      const tr_post_format = document.getElementById("item_attribute_post_format") ? document.getElementById("item_attribute_post_format").getBoundingClientRect().width : 0;

      this.data_table_width = sum + personal_width + dm_width + tr_category + tr_person_title_width + tr_specialty_categories_genres + tr_post_format + 80 + "px";

      const tr_name_width = document.getElementById("item_tr_name") ? document.getElementById("item_tr_name").getBoundingClientRect().width : 0;



      this.account_name_width = tr_name_width + "px";
      this.checkHeaderAreaOverlap();
    },
    /**
     * ヘッダーの左エリア（リスト名・タグ等）と右エリア（操作ボタン）が重なるかを実測して2段組を切り替える
     * 双方の実幅は2段組の有無で変わらないため、判定結果が反転し続けることはない
     */
    checkHeaderAreaOverlap() {
      const summary = this.$refs.list_summary;
      const menu = this.$refs.list_detail_menu;
      if (!summary || !menu) return;
      // 横スクロール時に縮んだ場合でも本来の幅で判定するためscrollWidthも参照する
      const summary_width = Math.max(summary.offsetWidth, summary.scrollWidth);
      const menu_width = Math.max(menu.offsetWidth, menu.scrollWidth);
      const available_width = document.documentElement.clientWidth - LIST_HEADER_STICKY_LEFT - LIST_HEADER_STICKY_RIGHT;
      this.header_area_stacked = summary_width + menu_width + LIST_HEADER_AREA_GAP > available_width;
    },
    /**
     * リスト名の変更やタグ追加など、左右エリアの内容が変わった場合も重なり判定をやり直す
     */
    observeHeaderAreaSize() {
      if (typeof ResizeObserver === "undefined") return;
      this.headerAreaObserver = new ResizeObserver(() => {
        this.checkHeaderAreaOverlap();
      });
      [this.$refs.list_summary, this.$refs.list_detail_menu].forEach((el) => {
        if (el) this.headerAreaObserver.observe(el);
      });
    },
    scrollTop() {
      window.scroll({ top: 0, behavior: "instant" });
    },
    searchDropdown(value) {
      this.search_dropdown_regexp = new RegExp(value, "ig");
    },
    searchDropdownAdd(value) {
      this.search_dropdown_add_regexp = new RegExp(value, "ig");
    },
    sidemenuScroll() {
      var target = document.getElementById(String(this.list_id));
      if (target) {
        var offsetTop = target.offsetTop;
        var sidemenuWrap = document.getElementById("sidemenu-wrap");
        var sidemenuHeight = sidemenuWrap.clientHeight;
        if (offsetTop > sidemenuHeight) {
          sidemenuWrap.scrollTop = offsetTop;
        }
      }
    },
    mouseoverSidemenu() {
      document.documentElement.style.overflow = "hidden";
    },
    mouseleaveSidemenu() {
      document.documentElement.style.overflow = "auto";
    },
    syncNewmessageCheckList() {
      this.checkListDetail = [];
      for (let i = 0; i < this.checkList.length; i++) {
        // for (let ii = 0; ii < this.list.influencer.length; ii++) {
        //   if (this.checkList[i] == this.list.influencer[ii].ig_id) {
        //     var detail = {
        //       account_name: this.list.influencer[ii].account_name,
        //       ig_id: this.list.influencer[ii].ig_id,
        //       name: this.list.influencer[ii].name,
        //       profile_picture_url: this.list.influencer[ii].profile_picture_url,
        //       badge: this.list.influencer[ii].badge,
        //     };
        //     this.checkListDetail.unshift(detail);
        //   }
        // }
        var ig_id = this.checkList[i];

        var detail = {
          account_name: this.list_detail.for_dm[ig_id].account_name,
          ig_id: this.list_detail.for_dm[ig_id].ig_id,
          name: this.list_detail.for_dm[ig_id].name,
          profile_picture_url: this.s3BaseUrl + "/profile_picture/" + this.list_detail.for_dm[ig_id].account_name + ".jpg",
          badge: this.list_detail.for_dm[ig_id].badge,
          followers_count: this.list_detail.for_dm[ig_id].followers_count,
          personalized_name: this.list_detail.for_dm[ig_id].personalized_name,
          personalized_price: this.list_detail.for_dm[ig_id].personalized_price,
        };
        this.checkListDetail.unshift(detail);
        if (i >= 149) break;
      }
      this.checkListDetail = this.checkListDetail.reverse();
    },
    openNewmessageDrawer() {
      if (this.permission.message.access) {
        this.syncNewmessageCheckList();
        this.newmessage_drawer = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    getBioSlideInfluencerIdField() {
      const map = {
        instagram: "ig_id",
        youtube: "channel_id",
        tiktok: "tt_id",
        twitter: "tw_id",
      };
      return map[this.list_detail.sns_type] || "ig_id";
    },
    getBioSlideAccountName(influencer) {
      if (this.list_detail.sns_type === "youtube") {
        return influencer.channel_name || influencer.channel_id;
      }
      return influencer.account_name || "";
    },
    syncBioSlideCheckList() {
      const idField = this.getBioSlideInfluencerIdField();
      const details = [];
      if (!this.list.influencer) {
        this.bio_slide_checkListDetail = [];
        return;
      }
      for (let i = 0; i < this.checkList.length && i < this.bio_slide_max_influencers; i++) {
        const selectedId = this.checkList[i];
        for (let j = 0; j < this.list.influencer.length; j++) {
          const inf = this.list.influencer[j];
          if (String(inf[idField]) === String(selectedId)) {
            details.push({
              account_name: this.getBioSlideAccountName(inf),
              influencer_id: String(inf[idField]),
            });
            break;
          }
        }
      }
      this.bio_slide_checkListDetail = details;
    },
    openBioSlideSettingModal() {
      if (this.checkList.length === 0) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "インフルエンサーを選択してください",
        });
        return;
      }
      if (!this.is_influencer_bio_slide.status) return;
      this.syncBioSlideCheckList();
      if (this.bio_slide_checkListDetail.length === 0) {
        this.$message.warning("選択中のインフルエンサー情報を取得できませんでした");
        return;
      }
      this.bio_slide_setting_modal = true;
    },
    onBioSlideCreated() {
      this.$store.dispatch("getUserData", {
        token: this.token,
        user_token: this.user_token,
      });
      this.bio_slide_complete_modal = true;
    },
    openMessageDrawer(ig_id) {
      this.dm_ig_id = ig_id;
      this.message_drawer = true;
      document.documentElement.style.overflow = "hidden";
    },
    closeMessageDrawer() {
      this.message_drawer = false;
      document.documentElement.style.overflow = "auto";
    },
    closeNewmessage() {
      this.newmessage_drawer = false;
      document.documentElement.style.overflow = "auto";
    },
    inquiry() {
      this.$intercom.show();
    },
    openAddInfluencer() {
      if (this.permission.list.edit) {
        this.add_influencer_modal = true;
        document.documentElement.style.overflow = "hidden";
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeGender(id, sns_type, gender, index) {
      this.axios.get(changeGenderAPI, {
        params: {
          id: id,
          sns_type: sns_type,
          gender: encodeURI(gender == "" ? "null" : gender),
          token: this.token,
        },
      });
      this.list.influencer[index].gender = gender;
    },
    changeBirthday(birthday, ig_id, index) {
      this.axios.get(changeBirthdayAPI, {
        params: {
          ig_id: ig_id,
          birthday: encodeURI(birthday == "" ? "null" : birthday),
          token: this.token,
        },
      });
      if (birthday != "") {
        let now = new Date().getFullYear() * 10000 + (new Date().getMonth() + 1) * 100 + new Date().getDate();
        let birth = Number(birthday.replaceAll("-", ""));
        var age = Math.floor((now - birth) / 10000);
      } else {
        age = "";
      }
      this.list.influencer[index].est_birthday = birthday;
      this.list.influencer[index].age = age;
      this.$forceUpdate();
    },
    inputBirthday(ig_id, index) {
      this.$prompt("誕生日を入力(yyyy-mm-ddで入力)", "誕生日を手動入力", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      })
        .then(({ value }) => {
          var v = value.match(/([0-9]{4})(-|年|\/)([0-9]{1,2})(-|月|\/)([0-9]{1,2})/);
          var y = v[1];
          var m = v[3];
          var d = v[5];
          if (m.length == 1) m = "0" + m;
          if (d.length == 1) d = "0" + d;
          var date = y + "-" + m + "-" + d;
          if (date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
            this.changeBirthday(date, ig_id, index);
            this.$message({
              type: "success",
              message: "誕生日を" + date + "に変更しました",
            });
          } else {
            this.$message({
              type: "success",
              message: "不正な値です",
            });
          }
        })
        .catch(() => {});
    },
    filterClose(value) {
      this.filter_show = value;
    },
    filterList(filtered) {
      this.filtered = filtered;
      if (this.filter.main_audience != "") {
        this.item.main_audience = true;
      }
      this.list = [];
      this.noinfluencer = false;
      this.count = 0;
      this.current_page = 1;
      this.infiniteId += 1;
    },
    imgError(index) {
      if (this.list_detail.sns_type == "instagram" || this.list_detail.sns_type == "tiktok") {
        this.list.influencer[index].profile_picture_url = this.s3BaseUrl + "/userdata/img_error_user.png";
      } else {
        this.list.influencer[index].thumbnails = this.s3BaseUrl + "/userdata/img_error_user.png";
      }
    },
    imgErrorPost(index, post_index) {
      var img = document.getElementById(index + "-" + post_index);
      if (img) img.setAttribute("src", this.s3BaseUrl + "/postdata/img_error_post_s.jpg");
    },
    openEditDrawer() {
      if (this.permission.list.edit) {
        this.edit_drawer = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    closeEditDrawer() {
      this.edit_drawer = false;
    },
    editBulkUpdate(select_item, update_value, update_type, column_id) {
      if (select_item == "tag") {
        this.list = [];
        if (this.list_view_style != "pagination") {
          this.checkList = [];
          this.checkAll_val = false;
          this.count = 0;
        }
        this.infiniteId += 1;
      } else {
        const firstNormalColumn = this.comment_columns.find((column) => column.column_type === "normal");
        const firstNormalColumnId = firstNormalColumn ? String(firstNormalColumn.column_id) : null;
        const targetColumnId = column_id != null ? String(column_id) : null;
        for (let i = 0; i < this.checkList.length; i++) {
          for (let ii = 0; ii < this.list.influencer.length; ii++) {
            if (this.list_detail.sns_type == "instagram") var id = this.list.influencer[ii].ig_id;
            if (this.list_detail.sns_type == "youtube") id = this.list.influencer[ii].channel_id;
            if (this.list_detail.sns_type == "tiktok") id = this.list.influencer[ii].tt_id;
            if (this.list_detail.sns_type == "twitter") id = this.list.influencer[ii].tw_id;
            if (this.checkList[i] == id) {
              if (select_item == "comment" && targetColumnId) {
                if (!this.list.influencer[ii].comment_values) {
                  this.$set(this.list.influencer[ii], "comment_values", {});
                }
                this.$set(this.list.influencer[ii].comment_values, targetColumnId, update_value);
                if (firstNormalColumnId === targetColumnId) {
                  this.list.influencer[ii].client_comment = update_value;
                }
              }
              if (select_item == "status") this.list.influencer[ii].status = update_value;
            }
          }
        }
      }
    },
    commentReactive(id, comment, list_id) {
      if (this.list_id == list_id) {
        if (this.list_detail.sns_type == "instagram") var id_type = "ig_id";
        if (this.list_detail.sns_type == "youtube") id_type = "channel_id";
        if (this.list_detail.sns_type == "tiktok") id_type = "tt_id";
        if (this.list_detail.sns_type == "twitter") id_type = "tw_id";
        for (let i = 0; i < this.list.influencer.length; i++) {
          if (this.list.influencer[i][id_type] == id) {
            this.list.influencer[i].client_comment = comment;
          }
        }
      }
    },
    noteReactive(id, note_info, property_name) {
      if (this.list_detail.sns_type == "instagram") var id_type = "ig_id";
      if (this.list_detail.sns_type == "youtube") id_type = "channel_id";
      if (this.list_detail.sns_type == "tiktok") id_type = "tt_id";
      if (this.list_detail.sns_type == "twitter") id_type = "tw_id";
      for (let i = 0; i < this.list.influencer.length; i++) {
        if (this.list.influencer[i][id_type] == id) {
          this.list.influencer[i].personal_data["personal_" + property_name] = note_info;
        }
      }
    },
    statusReactive(id, status, list_id) {
      if (this.list_id == list_id) {
        if (this.list_detail.sns_type == "instagram") var id_type = "ig_id";
        if (this.list_detail.sns_type == "youtube") id_type = "channel_id";
        if (this.list_detail.sns_type == "tiktok") id_type = "tt_id";
        if (this.list_detail.sns_type == "twitter") id_type = "tw_id";
        for (let i = 0; i < this.list.influencer.length; i++) {
          if (this.list.influencer[i][id_type] == id) {
            this.list.influencer[i].status = status;
          }
        }
      }
    },
    tagReactive(id, type, tag_index, new_tag) {
      if (this.list_detail.sns_type == "instagram") var id_type = "ig_id";
      if (this.list_detail.sns_type == "youtube") id_type = "channel_id";
      if (this.list_detail.sns_type == "tiktok") id_type = "tt_id";
      if (this.list_detail.sns_type == "twitter") id_type = "tw_id";
      for (let i = 0; i < this.list.influencer.length; i++) {
        if (this.list.influencer[i][id_type] == id) {
          if (type == "add") {
            this.list.influencer[i].tags.push(new_tag);
          } else if (type == "delete") {
            this.list.influencer[i].tags.splice(tag_index, 1);
          }
        }
      }
    },
    addMember(person_id, member_index, list_id) {
      if (this.permission.list.edit) {
        var params = new URLSearchParams();
        params.append("person_id", person_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(addMemberAPI, params).then(() => {
          this.list_detail.member_count += 1;
          this.list_detail.member[member_index].assign = true;
          this.list_detail[person_id] = true;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteMember(person_id, member_index, list_id) {
      if (this.permission.list.edit) {
        var params = new URLSearchParams();
        params.append("member_type", "member");
        params.append("person_id", person_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(deleteMemberFromListAPI, params).then(() => {
          this.list_detail.member_count -= 1;
          this.list_detail.member[member_index].assign = false;
          this.list_detail[person_id] = false;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeTargetClient(target_client_id, list_id) {
      if (this.permission.list.edit) {
        var params = new URLSearchParams();
        params.append("change_type", "target_client");
        params.append("target_client_id", target_client_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(changeListAPI, params).then((response) => {
          if (response.data.status == "OK") {
            this.list_detail.target_client_img_url = response.data.list_info.img_url;
            this.list_detail.target_client_id = response.data.list_info.target_client_id;
            this.list_detail.target_client_name = response.data.list_info.target_client_name;
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message,
            });
          }
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteClient(target_client_id, list_id) {
      if (this.permission.list.edit) {
        var params = new URLSearchParams();
        params.append("member_type", "client");
        params.append("person_id", target_client_id);
        params.append("list_id", list_id);
        params.append("token", this.token);
        this.axios.post(deleteMemberFromListAPI, params).then(() => {
          this.list_detail.target_client_id = null;
          this.list_detail.target_client_name = null;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    addTag(tag_id, list_id) {
      var params = new URLSearchParams();
      params.append("tag_id", tag_id);
      params.append("list_id", list_id);
      params.append("token", this.token);
      this.axios.post(addTagAPI, params).then(() => {
        this.list_detail.tag.push({
          mylist_list_id: list_id,
          mylist_tag_id: tag_id
        })
      });
    },
    removeTag(tag_id, tag_index, list_id) {
      var params = new URLSearchParams();
      params.append("tag_id", tag_id);
      params.append("list_id", list_id);
      params.append("token", this.token);
      this.axios.post(removeTagAPI, params).then(() => {
        this.list_detail.tag.splice(tag_index, 1);
      });
    },
    openSideMenu() {
      this.$store.dispatch("changeIsSideMenuClosed", false);
    },
    updateSiteInfo({darkLogo, logo, logoText, isOem}) {
      this.darkLogo = darkLogo;
      this.logo = logo;
      this.logoText = logoText;
      this.isOem = isOem;
    },
  },
  destroyed() {
    this.stopInfluencerUpdatePolling();
    window.removeEventListener("resize", this.calcWidth);
    if (this.headerAreaObserver) {
      this.headerAreaObserver.disconnect();
      this.headerAreaObserver = null;
    }
  },
  watch: {
    $route(to) {
      if (to.name == "listDetail" && !this.$route.params.backpage) {
        this.drawer = false;
        this.loadQuery();
        this.loadListDetail();
        this.loadList();
        this.startInfluencerUpdatePolling();
      }
    },
    checkList() {
      if (this.newmessage_drawer) {
        this.syncNewmessageCheckList();
      }
    },
    filter: {
      handler() {
        if (this.filter.post_keyword) {
          this.item.recent_post = true;
        }
      },
      deep: true,
    },
    member_select: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
    client_select: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
    item: {
      handler() {
        this.$nextTick(() => {
          this.calcWidth();
        });
      },
      deep: true,
    },
    comment_columns: {
      handler() {
        this.$nextTick(() => {
          this.calcWidth();
        });
      },
      deep: true,
    },
  },
  filters: {
    addComma(val) {
      if (val === null || val === undefined || val === "") {
        return "-";
      }

      const num = Number(val);
      if (Number.isNaN(num)) {
        return "-";
      }

      return Math.floor(num).toLocaleString();
    },
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>
<style>
.recent-post-1month-checkbox .el-checkbox__label {
  display: inline-block !important;
  padding-left: 0;
}

.recent-post-1month-checkbox {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 12px;
}

.recent-post-1month-checkbox .el-checkbox__input {
  margin-right: 6px;
}

.data-table-th-comment.list-comment-table-column {
  width: auto;
  min-width: 0;
  flex-shrink: 0;
  padding: 0 10px;
  box-sizing: border-box;
}

.list-comment-table-column .list-comment-header-group,
.list-comment-table-column .list-comment-cells {
  width: max-content;
  min-width: 0;
}

.list-comment-table-column .list-comment-cell-item .data-table-list-comment {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.influencer-update-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 16px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.4;
}

.influencer-update-status.updating {
  color: #b8820c;
  background: rgba(230, 162, 60, 0.15);
}

.influencer-update-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.influencer-update-status.updating .influencer-update-status-dot {
  animation: influencer-update-pulse 1.2s ease-in-out infinite;
}

@keyframes influencer-update-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.influencer-updating-avatar-badge {
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  padding: 1px 5px;
  border-radius: 8px;
  background: rgba(230, 162, 60, 0.95);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
</style>